import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';
import atributoService from '../services/atributoService';
import plameConfiguracionService from '../services/plameConfiguracionService';
import regimenLaboralService from '../services/regimenLaboralService';
import formulaService from '../services/formulaService';
import afpService from '../services/afpService';
import informacionGeneralService from '../services/informacionGeneralService';
import tramoRentaService from '../services/tramoRentaService';
import configuracionRentaQuintaService from '../services/configuracionRentaQuintaService';
import fechasComputoRhService from '../services/fechasComputoRhService';
import calculosBoletaService from '../services/calculosBoletaService';
import calculosBoletaInternaService from '../services/calculosBoletaInternaService';
import migoService from '../services/migoService';
import empleadoService from '../services/empleadoService';
import configuracionPlanillaAlternativaService from '../services/configuracionPlanillaAlternativaService';
import configuracionViaticosStandardService from '../services/configuracionViaticosStandardService';
import configuracionExpedienteLaboralService from '../services/configuracionExpedienteLaboralService';
import configuracionSsomaService from '../services/configuracionSsomaService';
import ExpedienteLaboralTab from './ExpedienteLaboralTab';
import SsomaTallasTab from './SsomaTallasTab';
import ConstruccionCivilFichaEmpleado from './ConstruccionCivilFichaEmpleado';
import construccionCivilService from '../services/construccionCivilService';
import { MOTIVOS_CESE, motivoCeseEnLista } from '../constants/motivosCese';
import { obtenerTiposContratacionEmpleado, esTipoContratacionEmpleadoValido } from '../constants/tiposContratacionEmpleado';

function fechaHistorialAInput(val) {
  if (!val) return '';
  return String(val).split('T')[0];
}

function formatearFechaHistorialDisplay(val) {
  const iso = fechaHistorialAInput(val);
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
}

function esRegimenConstruccionCivil(regimenLaboral, regimenesLaborales = []) {
  const hallado = regimenesLaborales.find((r) => r.nombre === regimenLaboral);
  const codigo = String(hallado?.codigo || '').toUpperCase();
  if (codigo === 'CONSU' || codigo === 'CONSTRUCCION') return true;
  return String(regimenLaboral || '').toLowerCase().includes('construcción');
}

const EmpleadoForm = ({
  empleado = null,
  onSubmit,
  onCancel,
  isLoading = false,
  migoToken = null,
  modoEdicion = false,
  historialLaboralEdicion = [],
  historialLaboralInternoEdicion = [],
  onHistorialLaboralActualizado = null,
}) => {
  const { selectedCompany } = useAuth();
  const [planillaAlternativaActiva, setPlanillaAlternativaActiva] = useState(false);
  const [viaticosStandardActivo, setViaticosStandardActivo] = useState(false);
  const [expedienteLaboralActivo, setExpedienteLaboralActivo] = useState(false);
  const [ssomaActivo, setSsomaActivo] = useState(false);
  const [fichaConsu, setFichaConsu] = useState({
    categoria: 'operario',
    modalidad_beneficios: 'sin_beneficios',
    escolaridad_pago_mensual: false,
    afiliacion_salud: 'essalud',
  });
  const [parametrosConsu, setParametrosConsu] = useState([]);
  
  // Estados para atributos del sistema
  const [atributosData, setAtributosData] = useState({});
  const [loadingAtributos, setLoadingAtributos] = useState(true);
  
  // Estados para regímenes laborales
  const [regimenesLaborales, setRegimenesLaborales] = useState([]);
  const [loadingRegimenes, setLoadingRegimenes] = useState(true);
  
  // Estados para fórmulas
  const [formulas, setFormulas] = useState([]);
  const [loadingFormulas, setLoadingFormulas] = useState(false);

  // Estados para datos completos de AFPs
  const [afpsData, setAfpsData] = useState([]);
  const [loadingAfpsData, setLoadingAfpsData] = useState(false);

  // Estados para información general (UIT y Sueldo Mínimo)
  const [informacionGeneral, setInformacionGeneral] = useState({});
  const [loadingInformacionGeneral, setLoadingInformacionGeneral] = useState(false);

  // Estados para tramos de renta
  const [tramosRenta, setTramosRenta] = useState([]);
  const [loadingTramosRenta, setLoadingTramosRenta] = useState(false);

  // Estados para configuración de renta de quinta
  const [configuracionRentaQuinta, setConfiguracionRentaQuinta] = useState(null);
  const [loadingConfigRentaQuinta, setLoadingConfigRentaQuinta] = useState(false);
  const [opcionesComputoRh, setOpcionesComputoRh] = useState([]);
  const [loadingComputoRh, setLoadingComputoRh] = useState(false);

  // Estados del formulario
  const [formData, setFormData] = useState({
    // Información Personal
    nombreCompleto: '',
    tipoDocumento: 'DNI',
    numeroDocumento: '',
    fechaNacimiento: '',
    sexo: '',
    estadoCivil: '',
    numeroHijos: 0,
    telefono: '',
    email: '',
    direccion: '',
    distrito: '',
    provincia: '',
    departamento: '',
    
    // Información Laboral
    cargo: '',
    categoria: '',
    proyecto: '',
    areaTrabajo: '',
    tipoContratacion: '',
    fechaIngreso: '',
    fechaIngresoInterna: '',
    fechaCese: '',
    motivoCese: '',
    estado: 'Activo',
    tipoPlanilla: 'dual',
    regimenLaboral: '',
    computoRhId: '',
    
    // Información Salarial
    sueldoBasico: '',
    formaPago: 'mensual',
    sueldoInterno: '',
    asignacionFamiliar: false,
    tieneBono: false,
    montoBono: '',
    montoViaticoStandard: '',
    esBoletaLiquidada: false,
    
    // Conceptos dinámicos - INICIAR VACÍO
    ingresos: [],
    descuentos: [],
    aportes: [],
    // Planilla alternativa dual: boleta de control (sin ONP/AFP ni aportes al generar)
    ingresosInternos: [],
    descuentosInternos: [],
    aportesInternos: [],
    
    // Aportes adicionales
    tipoAfp: 'Flujo',
    
    // Sistema Pensionario
    sistemaPensionario: 'ONP',
    afp: '',
    cuspp: '',
    fechaAfiliacion: '',
    comisionAfp: '',
    
    // Horarios
    horarioTrabajo: 'completo',
    horaEntrada: '08:00',
    horaSalida: '17:00',
    horasSemanales: 48,
    diasTrabajo: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'],
    
    // Información Adicional
    cuentaBancaria: '',
    banco: '',
    cci: '',
    cuentaCts: '',
    bancoCts: '',
    contactoEmergencia: '',
    telefonoEmergencia: '',
    observaciones: ''
  });

  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState('personal');
  const [atributos, setAtributos] = useState([]);
  const [historialLocal, setHistorialLocal] = useState([]);
  const [historialInternoLocal, setHistorialInternoLocal] = useState([]);
  const [guardandoHistorialId, setGuardandoHistorialId] = useState(null);
  const guardandoHistorialRef = useRef(false);
  const pendienteRecalcConsuEdicionRef = useRef(null);
  const consuDebounceHabilitadoRef = useRef(!modoEdicion);
  const consuRecalcEnCursoRef = useRef(false);
  const [mensajeHistorial, setMensajeHistorial] = useState(null);
  const [showEditarHistorialModal, setShowEditarHistorialModal] = useState(false);
  const [editandoHistorial, setEditandoHistorial] = useState(null);
  const [historialModalTipo, setHistorialModalTipo] = useState('plame'); // plame | interno
  const [fechaIngresoEdit, setFechaIngresoEdit] = useState('');
  const [fechaCeseEdit, setFechaCeseEdit] = useState('');
  const [motivoCeseEdit, setMotivoCeseEdit] = useState('');

  // Estados para buscador PLAME
  const [codigosPlame, setCodigosPlame] = useState([]);
  const [loadingPlame, setLoadingPlame] = useState(false);
  const [buscadorVisible, setBuscadorVisible] = useState(false);
  const [tipoConceptoActual, setTipoConceptoActual] = useState('');
  const [terminoBusqueda, setTerminoBusqueda] = useState('');
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [montoModal, setMontoModal] = useState('');
  const [conceptoSeleccionado, setConceptoSeleccionado] = useState(null);

  // Estados para mostrar fórmulas en el modal
  const [formulasDisponibles, setFormulasDisponibles] = useState([]);
  const [formulaSeleccionada, setFormulaSeleccionada] = useState(null);
  const [calculoFormula, setCalculoFormula] = useState(null);
  const [mostrarFormulas, setMostrarFormulas] = useState(false);

  // Estados para edición de montos (por concepto individual)
  const [editandoConcepto, setEditandoConcepto] = useState({});

  // Estados para consulta de DNI con MIGO
  const [consultandoDNI, setConsultandoDNI] = useState(false);
  const [tokenMigo, setTokenMigo] = useState('oxzdu4ZBlghIaetvqYux8CocEVJABQAkptMBcpUyQVhXr5sF3vb0ABZxJF40'); // Token de MIGO configurado

  // Estados para el guardado del empleado
  const [guardandoEmpleado, setGuardandoEmpleado] = useState(false);
  const [mensajeExito, setMensajeExito] = useState('');
  const [mensajeError, setMensajeError] = useState('');

  // 📊 ESTADOS PARA BARRA DE PROGRESO Y TRACKING DE APIS
  const [cargandoProgreso, setCargandoProgreso] = useState({
    progreso: 0,
    total: 7, // Ahora incluye configuración de renta de quinta
    apiActual: '',
    apisCompletadas: [],
    tiempoInicio: null
  });

  // 📊 FUNCIÓN PARA ACTUALIZAR PROGRESO DE CARGA
  const actualizarProgreso = (apiNombre, completada = false) => {
    setCargandoProgreso(prev => {
      const nuevasCompletadas = completada && !prev.apisCompletadas.includes(apiNombre)
        ? [...prev.apisCompletadas, apiNombre]
        : prev.apisCompletadas;
      
      return {
        ...prev,
        progreso: nuevasCompletadas.length,
        apiActual: completada ? '' : apiNombre,
        apisCompletadas: nuevasCompletadas
      };
    });
  };

  // 🔄 FUNCIÓN PARA CARGAR TODAS LAS APIS CON PROGRESO
  const cargarTodasLasApis = async () => {
    console.log('🔄🔄🔄 === INICIANDO CARGA CON PROGRESO EN EMPLEADO FORM === 🔄🔄🔄');
    
    // Inicializar progreso
    setCargandoProgreso(prev => ({
      ...prev,
      progreso: 0,
      apisCompletadas: [],
      tiempoInicio: Date.now(),
      apiActual: 'Inicializando...'
    }));

    // Cargar APIs secuencialmente para mostrar progreso
    console.log('📊 Cargando Atributos...');
    actualizarProgreso('📊 Atributos');
    await cargarAtributos();
    actualizarProgreso('📊 Atributos', true);

    console.log('🏛️ Cargando Regímenes Laborales...');
    actualizarProgreso('🏛️ Regímenes Laborales');
    await cargarRegimenesLaborales();
    actualizarProgreso('🏛️ Regímenes Laborales', true);

    console.log('🧮 Cargando Fórmulas...');
    actualizarProgreso('🧮 Fórmulas');
    await cargarFormulas();
    actualizarProgreso('🧮 Fórmulas', true);

    console.log('🏦 Cargando AFPs...');
    actualizarProgreso('🏦 AFPs');
    await cargarAfps();
    actualizarProgreso('🏦 AFPs', true);

    console.log('ℹ️ Cargando Información General...');
    actualizarProgreso('ℹ️ Información General');
    await cargarInformacionGeneral();
    actualizarProgreso('ℹ️ Información General', true);

    console.log('💰 Cargando Tramos de Renta...');
    actualizarProgreso('💰 Tramos de Renta');
    await cargarTramosRenta();
    actualizarProgreso('💰 Tramos de Renta', true);

    console.log('💸 Cargando Configuración de Renta de Quinta...');
    actualizarProgreso('💸 Configuración Renta Quinta');
    await cargarConfiguracionRentaQuinta();
    actualizarProgreso('💸 Configuración Renta Quinta', true);

    // Finalizar progreso
    const tiempoTotal = Date.now() - cargandoProgreso.tiempoInicio;
    console.log(`✅✅✅ CARGA COMPLETADA EN ${tiempoTotal}ms`);
    console.log(`📊 APIs cargadas: ${cargandoProgreso.apisCompletadas.length}/${cargandoProgreso.total}`);
    
    setCargandoProgreso(prev => ({
      ...prev,
      apiActual: '',
      progreso: prev.total
    }));
  };

  // Cargar APIs con progreso y configurar token MIGO
  useEffect(() => {
    cargarTodasLasApis();
    
    // Configurar token de MIGO al cargar el componente
    if (tokenMigo) {
      migoService.setToken(tokenMigo);
      console.log('🔑 Token de MIGO configurado al inicializar el componente');
    }
  }, [selectedCompany]);

  useEffect(() => {
    const cargarPlanillaAlternativa = async () => {
      if (!selectedCompany?.id) {
        setPlanillaAlternativaActiva(false);
        return;
      }
      try {
        const response = await configuracionPlanillaAlternativaService.verificarEstado(selectedCompany.id);
        setPlanillaAlternativaActiva(Boolean(response?.data?.planilla_alternativa_activa));
      } catch (error) {
        console.error('Error al verificar planilla alternativa:', error);
        setPlanillaAlternativaActiva(false);
      }
    };

    cargarPlanillaAlternativa();

    const onConfigActualizada = () => cargarPlanillaAlternativa();
    window.addEventListener('configuracion-planilla-alternativa-actualizada', onConfigActualizada);
    return () => {
      window.removeEventListener('configuracion-planilla-alternativa-actualizada', onConfigActualizada);
    };
  }, [selectedCompany?.id]);

  useEffect(() => {
    const cargarViaticosStandard = async () => {
      if (!selectedCompany?.id) {
        setViaticosStandardActivo(false);
        return;
      }
      try {
        const response = await configuracionViaticosStandardService.verificarEstado(selectedCompany.id);
        setViaticosStandardActivo(
          Boolean(response?.data?.viaticos_standard_activo ?? response?.data?.activo)
        );
      } catch (error) {
        console.error('Error al verificar viáticos standard:', error);
        setViaticosStandardActivo(false);
      }
    };

    cargarViaticosStandard();

    const onConfigActualizada = () => cargarViaticosStandard();
    window.addEventListener('configuracion-viaticos-standard-actualizada', onConfigActualizada);
    return () => {
      window.removeEventListener('configuracion-viaticos-standard-actualizada', onConfigActualizada);
    };
  }, [selectedCompany?.id]);

  useEffect(() => {
    const cargarExpedienteLaboral = async () => {
      if (!selectedCompany?.id) {
        setExpedienteLaboralActivo(false);
        return;
      }
      try {
        const response = await configuracionExpedienteLaboralService.verificarEstado(selectedCompany.id);
        setExpedienteLaboralActivo(
          Boolean(response?.data?.expediente_laboral_activo ?? response?.data?.activo)
        );
      } catch (error) {
        console.error('Error al verificar expediente laboral:', error);
        setExpedienteLaboralActivo(false);
      }
    };

    cargarExpedienteLaboral();

    const onConfigActualizada = () => cargarExpedienteLaboral();
    window.addEventListener('configuracion-expediente-laboral-actualizada', onConfigActualizada);
    return () => {
      window.removeEventListener('configuracion-expediente-laboral-actualizada', onConfigActualizada);
    };
  }, [selectedCompany?.id]);

  useEffect(() => {
    const cargarSsoma = async () => {
      if (!selectedCompany?.id) {
        setSsomaActivo(false);
        return;
      }
      try {
        const response = await configuracionSsomaService.verificarEstado(selectedCompany.id);
        setSsomaActivo(Boolean(response?.data?.ssoma_activo ?? response?.data?.activo));
      } catch (error) {
        console.error('Error al verificar SSOMA:', error);
        setSsomaActivo(false);
      }
    };

    cargarSsoma();

    const onConfigActualizada = () => cargarSsoma();
    window.addEventListener('configuracion-ssoma-actualizada', onConfigActualizada);
    return () => {
      window.removeEventListener('configuracion-ssoma-actualizada', onConfigActualizada);
    };
  }, [selectedCompany?.id]);

  useEffect(() => {
    let cancelado = false;
    const cargarConsu = async () => {
      const params = await construccionCivilService.parametrosGlobales();
      if (!cancelado && params.success) setParametrosConsu(params.data || []);
      if (!empleado?.id || !selectedCompany?.id) return;
      const f = await construccionCivilService.ficha(selectedCompany.id, empleado.id);
      if (cancelado || !f.success || !f.data?.ficha) return;
      setFichaConsu((prev) => ({
        ...prev,
        categoria: f.data.ficha.categoria || prev.categoria,
        modalidad_beneficios: f.data.ficha.modalidad_beneficios || prev.modalidad_beneficios,
        escolaridad_pago_mensual: !!f.data.ficha.escolaridad_pago_mensual,
        afiliacion_salud: f.data.ficha.afiliacion_salud || prev.afiliacion_salud,
      }));
    };
    cargarConsu();
    return () => { cancelado = true; };
  }, [empleado?.id, selectedCompany?.id]);

  useEffect(() => {
    const cargarComputosRh = async () => {
      if (!selectedCompany?.id) {
        setOpcionesComputoRh([]);
        return;
      }

      try {
        setLoadingComputoRh(true);
        const response = await fechasComputoRhService.obtenerFechas(selectedCompany.id);
        if (response.success) {
          setOpcionesComputoRh(response.data || []);
        } else {
          setOpcionesComputoRh([]);
        }
      } catch (error) {
        console.error('Error al cargar cómputos RH para empleado:', error);
        setOpcionesComputoRh([]);
      } finally {
        setLoadingComputoRh(false);
      }
    };

    cargarComputosRh();
  }, [selectedCompany]);

  useEffect(() => {
    if (!modoEdicion) return;
    const mapped = (historialLaboralEdicion || []).map((r) => ({
      ...r,
      fecha_ingreso: fechaHistorialAInput(r.fecha_ingreso),
      fecha_cese: fechaHistorialAInput(r.fecha_cese),
      motivo_cese: r.motivo_cese || '',
    }));
    setHistorialLocal(mapped);
  }, [historialLaboralEdicion, modoEdicion]);

  useEffect(() => {
    if (!modoEdicion) return;
    const mapped = (historialLaboralInternoEdicion || []).map((r) => ({
      ...r,
      fecha_ingreso: fechaHistorialAInput(r.fecha_ingreso),
      fecha_cese: fechaHistorialAInput(r.fecha_cese),
      motivo_cese: r.motivo_cese || '',
    }));
    setHistorialInternoLocal(mapped);
  }, [historialLaboralInternoEdicion, modoEdicion]);

  const actualizarCampoHistorialLocal = (registroId, campo, valor, tipo = 'plame') => {
    const setter = tipo === 'interno' ? setHistorialInternoLocal : setHistorialLocal;
    setter((prev) =>
      prev.map((r) => {
        if (r.id !== registroId) return r;
        const next = { ...r, [campo]: valor };
        if (campo === 'fecha_cese' && !valor) {
          next.motivo_cese = '';
        }
        return next;
      })
    );
  };

  const cerrarModalEditarHistorial = () => {
    setShowEditarHistorialModal(false);
    setEditandoHistorial(null);
    setHistorialModalTipo('plame');
    setFechaIngresoEdit('');
    setFechaCeseEdit('');
    setMotivoCeseEdit('');
  };

  const abrirModalNuevoHistorial = (tipo = 'plame') => {
    setHistorialModalTipo(tipo);
    setEditandoHistorial(null);
    setFechaIngresoEdit('');
    setFechaCeseEdit('');
    setMotivoCeseEdit('');
    setShowEditarHistorialModal(true);
  };

  const abrirModalEditarHistorial = (registro, tipo = 'plame') => {
    setHistorialModalTipo(tipo);
    setEditandoHistorial(registro);
    setFechaIngresoEdit(registro.fecha_ingreso || '');
    setFechaCeseEdit(registro.fecha_cese || '');
    setMotivoCeseEdit(motivoCeseEnLista(registro.motivo_cese || ''));
    setShowEditarHistorialModal(true);
  };

  const guardarEdicionHistorialModal = async () => {
    if (guardandoHistorialRef.current) return;
    const esNuevo = !editandoHistorial?.id;
    if (!empleado?.id) {
      setMensajeHistorial({ tipo: 'error', texto: 'No se pudo identificar el empleado.' });
      return;
    }
    if (!fechaIngresoEdit) {
      setMensajeHistorial({ tipo: 'error', texto: 'La fecha de ingreso es obligatoria.' });
      return;
    }
    if (fechaCeseEdit && fechaCeseEdit < fechaIngresoEdit) {
      setMensajeHistorial({ tipo: 'error', texto: 'La fecha de cese no puede ser anterior al ingreso.' });
      return;
    }
    if (fechaCeseEdit && !motivoCeseEdit) {
      setMensajeHistorial({ tipo: 'error', texto: 'Seleccione el motivo de cese.' });
      return;
    }

    const payload = {
      empleado_id: empleado.id,
      fecha_ingreso: fechaIngresoEdit,
      fecha_cese: fechaCeseEdit || null,
      motivo_cese: fechaCeseEdit ? motivoCeseEdit : null,
    };

    try {
      guardandoHistorialRef.current = true;
      setGuardandoHistorialId(esNuevo ? 'nuevo' : editandoHistorial.id);
      setMensajeHistorial(null);

      if (esNuevo) {
        if (historialModalTipo === 'interno') {
          await empleadoService.createHistorialLaboralInterno(payload);
          if (!payload.fecha_cese) {
            handleInputChange('fechaIngresoInterna', payload.fecha_ingreso);
          }
        } else {
          await empleadoService.createHistorialLaboral(payload);
          if (!payload.fecha_cese) {
            handleInputChange('fechaIngreso', payload.fecha_ingreso);
          }
        }
      } else if (historialModalTipo === 'interno') {
        await empleadoService.updateHistorialLaboralInterno(empleado.id, editandoHistorial.id, payload);
        if (!payload.fecha_cese) {
          handleInputChange('fechaIngresoInterna', payload.fecha_ingreso);
        }
        actualizarCampoHistorialLocal(editandoHistorial.id, 'fecha_ingreso', payload.fecha_ingreso, 'interno');
        actualizarCampoHistorialLocal(editandoHistorial.id, 'fecha_cese', payload.fecha_cese || '', 'interno');
        actualizarCampoHistorialLocal(editandoHistorial.id, 'motivo_cese', payload.motivo_cese || '', 'interno');
      } else {
        await empleadoService.updateHistorialLaboral(empleado.id, editandoHistorial.id, payload);
        if (!payload.fecha_cese) {
          handleInputChange('fechaIngreso', payload.fecha_ingreso);
        }
        actualizarCampoHistorialLocal(editandoHistorial.id, 'fecha_ingreso', payload.fecha_ingreso, 'plame');
        actualizarCampoHistorialLocal(editandoHistorial.id, 'fecha_cese', payload.fecha_cese || '', 'plame');
        actualizarCampoHistorialLocal(editandoHistorial.id, 'motivo_cese', payload.motivo_cese || '', 'plame');
      }

      if (onHistorialLaboralActualizado) {
        await onHistorialLaboralActualizado();
      }
      cerrarModalEditarHistorial();
      setMensajeHistorial({
        tipo: 'success',
        texto: esNuevo ? 'Historial agregado correctamente.' : 'Historial actualizado correctamente.',
      });
      setTimeout(() => setMensajeHistorial(null), 4000);
    } catch (err) {
      setMensajeHistorial({
        tipo: 'error',
        texto: err.message || 'Error al guardar el historial laboral.',
      });
    } finally {
      guardandoHistorialRef.current = false;
      setGuardandoHistorialId(null);
    }
  };

  // Cargar datos del empleado si está editando
  useEffect(() => {
    if (empleado) {
      console.log('📊 MODO EDICIÓN - Datos del empleado recibidos de la API:');
      console.log('===============================================');
      console.log('🔍 Datos completos del empleado:', empleado);
      console.log('📋 Estructura de datos:');
      console.log('  - ID:', empleado.id);
      console.log('  - Nombre Completo:', empleado.nombreCompleto);
      console.log('  - Documento:', empleado.numeroDocumento);
      console.log('  - Estado:', empleado.estado);
      console.log('  - Régimen Laboral:', empleado.regimenLaboral);
      console.log('  - Sueldo Básico:', empleado.sueldoBasico);
      console.log('  - Conceptos:');
      console.log('    * Ingresos:', empleado.ingresos);
      console.log('    * Descuentos:', empleado.descuentos);
      console.log('    * Aportes:', empleado.aportes);
      
      if (historialLaboralEdicion && historialLaboralEdicion.length > 0) {
        console.log('📚 Historial Laboral de Edición:');
        console.log('  - Registros:', historialLaboralEdicion.length);
        console.log('  - Datos:', historialLaboralEdicion);
      }
      
      console.log('🔧 Aplicando datos al formulario...');
      console.log('===============================================');
      
      // Procesar fechas para el formulario
      const empleadoProcesado = { ...empleado };
      
      // Procesar fecha de nacimiento
      if (empleadoProcesado.fechaNacimiento) {
        const fechaOriginal = empleadoProcesado.fechaNacimiento;
        // Convertir de formato ISO a formato YYYY-MM-DD para input date
        const fechaFormateada = new Date(fechaOriginal).toISOString().split('T')[0];
        empleadoProcesado.fechaNacimiento = fechaFormateada;
        console.log('📅 Fecha de nacimiento procesada:');
        console.log('  - Original:', fechaOriginal);
        console.log('  - Formateada:', fechaFormateada);
      }
      
      // Procesar fecha de ingreso
      if (empleadoProcesado.fechaIngreso) {
        const fechaOriginal = empleadoProcesado.fechaIngreso;
        const fechaFormateada = new Date(fechaOriginal).toISOString().split('T')[0];
        empleadoProcesado.fechaIngreso = fechaFormateada;
        console.log('📅 Fecha de ingreso procesada:');
        console.log('  - Original:', fechaOriginal);
        console.log('  - Formateada:', fechaFormateada);
      }

      if (empleadoProcesado.fechaIngresoInterna) {
        empleadoProcesado.fechaIngresoInterna = new Date(empleadoProcesado.fechaIngresoInterna)
          .toISOString()
          .split('T')[0];
      }

      if (!empleadoProcesado.tipoPlanilla) {
        empleadoProcesado.tipoPlanilla = 'dual';
      }
      
      // Procesar fecha de cese si existe
      if (empleadoProcesado.fechaCese) {
        const fechaOriginal = empleadoProcesado.fechaCese;
        const fechaFormateada = new Date(fechaOriginal).toISOString().split('T')[0];
        empleadoProcesado.fechaCese = fechaFormateada;
        console.log('📅 Fecha de cese procesada:');
        console.log('  - Original:', fechaOriginal);
        console.log('  - Formateada:', fechaFormateada);
      }
      
      // Procesar fecha de afiliación si existe
      if (empleadoProcesado.fechaAfiliacion) {
        const fechaOriginal = empleadoProcesado.fechaAfiliacion;
        const fechaFormateada = new Date(fechaOriginal).toISOString().split('T')[0];
        empleadoProcesado.fechaAfiliacion = fechaFormateada;
        console.log('📅 Fecha de afiliación procesada:');
        console.log('  - Original:', fechaOriginal);
        console.log('  - Formateada:', fechaFormateada);
      }
      
      // Mapear área de trabajo del empleado existente
      const areaTrabajoValue = empleadoProcesado.areas_de_trabajo || empleadoProcesado.areaTrabajo || '';
      console.log('🏢 Área de trabajo del empleado:', areaTrabajoValue);
      
      // ===== LOGGING DETALLADO PARA CHECKBOXES EN EMPLEADO FORM =====
      console.log('🔍 [EmpleadoForm] CAMPOS ORIGINALES DE CHECKBOXES DESDE EDITAREMPLEADO:', {
        // Formato snake_case (del backend directo)
        asignacion_familiar: empleadoProcesado.asignacion_familiar,
        tipo_asignacion_familiar: typeof empleadoProcesado.asignacion_familiar,
        tiene_bono: empleadoProcesado.tiene_bono,
        tipo_tiene_bono: typeof empleadoProcesado.tiene_bono,
        monto_bono: empleadoProcesado.monto_bono,
        tipo_monto_bono: typeof empleadoProcesado.monto_bono,
        es_boleta_liquidada: empleadoProcesado.es_boleta_liquidada,
        tipo_es_boleta_liquidada: typeof empleadoProcesado.es_boleta_liquidada,
        // Formato camelCase (del mapeo de EditarEmpleado)
        asignacionFamiliar: empleadoProcesado.asignacionFamiliar,
        tipo_asignacionFamiliar: typeof empleadoProcesado.asignacionFamiliar,
        tieneBono: empleadoProcesado.tieneBono,
        tipo_tieneBono: typeof empleadoProcesado.tieneBono,
        montoBono: empleadoProcesado.montoBono,
        tipo_montoBono: typeof empleadoProcesado.montoBono,
        esBoletaLiquidada: empleadoProcesado.esBoletaLiquidada,
        tipo_esBoletaLiquidada: typeof empleadoProcesado.esBoletaLiquidada
      });
      
      const configuracionesAdicionales = {
        asignacionFamiliar: empleadoProcesado.asignacionFamiliar || empleadoProcesado.asignacion_familiar || false,
        tieneBono: empleadoProcesado.tieneBono || empleadoProcesado.tiene_bono || false,
        montoBono: empleadoProcesado.montoBono || empleadoProcesado.monto_bono || '',
        montoViaticoStandard:
          empleadoProcesado.montoViaticoStandard ??
          empleadoProcesado.monto_viatico_standard ??
          '',
        esBoletaLiquidada: empleadoProcesado.esBoletaLiquidada || empleadoProcesado.es_boleta_liquidada || false
      };
      
      console.log('⚙️ [EmpleadoForm] CONFIGURACIONES ADICIONALES MAPEADAS PARA FORMDATA:', {
        asignacionFamiliar: configuracionesAdicionales.asignacionFamiliar,
        tipo_asignacionFamiliar: typeof configuracionesAdicionales.asignacionFamiliar,
        tieneBono: configuracionesAdicionales.tieneBono,
        tipo_tieneBono: typeof configuracionesAdicionales.tieneBono,
        montoBono: configuracionesAdicionales.montoBono,
        tipo_montoBono: typeof configuracionesAdicionales.montoBono,
        esBoletaLiquidada: configuracionesAdicionales.esBoletaLiquidada,
        tipo_esBoletaLiquidada: typeof configuracionesAdicionales.esBoletaLiquidada
      });
      // ===============================================================
      
      setFormData(prev => {
        const newFormData = {
          ...prev,
          ...empleadoProcesado,
          areaTrabajo: areaTrabajoValue,  // Mapear explícitamente el área de trabajo
          computoRhId: empleadoProcesado.computoRhId || empleadoProcesado.fecha_computo_rh_id || '',
          formaPago:
            empleadoProcesado.formaPago
            || empleadoProcesado.forma_pago
            || 'mensual',
          ...configuracionesAdicionales   // Mapear explícitamente las configuraciones adicionales
        };
        
        // ===== LOGGING FINAL DEL FORMDATA =====
        console.log('📋 [EmpleadoForm] FORMDATA FINAL DESPUÉS DE setFormData:', {
          asignacionFamiliar: newFormData.asignacionFamiliar,
          tipo_asignacionFamiliar: typeof newFormData.asignacionFamiliar,
          tieneBono: newFormData.tieneBono,
          tipo_tieneBono: typeof newFormData.tieneBono,
          montoBono: newFormData.montoBono,
          tipo_montoBono: typeof newFormData.montoBono,
          esBoletaLiquidada: newFormData.esBoletaLiquidada,
          tipo_esBoletaLiquidada: typeof newFormData.esBoletaLiquidada,
          formData_completo: newFormData
        });
        console.log('===============================================');
        // =========================================
        
        return newFormData;
      });

      if (
        modoEdicion
        && esRegimenConstruccionCivil(
          empleadoProcesado.regimenLaboral,
          regimenesLaborales
        )
      ) {
        pendienteRecalcConsuEdicionRef.current = empleado.id;
        consuDebounceHabilitadoRef.current = false;
      }
    }
  }, [empleado, historialLaboralEdicion, modoEdicion, regimenesLaborales]);

  // Configurar token de MIGO cuando se pasa como prop
  useEffect(() => {
    if (migoToken) {
      setTokenMigo(migoToken);
      console.log('✅ Token de MIGO configurado para consulta automática de DNI');
    }
  }, [migoToken]);

  // Monitorear cambios en atributosData para depuración
  useEffect(() => {
    console.log('🔄 AtributosData cambió:', atributosData);
    if (atributosData && Object.keys(atributosData).length > 0) {
      console.log('📊 Keys disponibles en atributosData:', Object.keys(atributosData));
      console.log('🏢 Areas de Trabajo disponibles:', atributosData['Areas de Trabajo']);
    }
  }, [atributosData]);

  const cargarAtributos = async () => {
    if (!selectedCompany?.id) return;
    
    try {
      setLoadingAtributos(true);
      const response = await atributoService.obtenerConfiguracionCompleta(selectedCompany.id);
      
      if (response.success) {
        const subAtributos = response.data.sub_atributos || {};
        console.log('📋 Atributos cargados completos:', response.data);
        console.log('📋 Sub-atributos:', subAtributos);
        console.log('🏢 Areas de Trabajo encontradas:', subAtributos['Areas de Trabajo']);
        console.log('🔧 Todas las keys de subAtributos:', Object.keys(subAtributos));
        
        // Verificar si Areas de Trabajo existe y tiene datos
        if (subAtributos['Areas de Trabajo']) {
          console.log('✅ Areas de Trabajo estructura:', subAtributos['Areas de Trabajo']);
          console.log('✅ Areas de Trabajo longitud:', subAtributos['Areas de Trabajo'].length);
        } else {
          console.warn('❌ No se encontraron Areas de Trabajo en la respuesta');
          console.log('🔍 Verificando keys que contengan "area":', 
            Object.keys(subAtributos).filter(key => 
              key.toLowerCase().includes('area') || 
              key.toLowerCase().includes('trabajo')
            )
          );
          
          // Intentar diferentes variaciones del nombre
          const possibleKeys = [
            'Areas de Trabajo', 
            'Área de Trabajo', 
            'areas_de_trabajo', 
            'area_de_trabajo',
            'AREAS DE TRABAJO',
            'Area de Trabajo'
          ];
          
          console.log('🔍 Buscando variaciones de keys:');
          possibleKeys.forEach(key => {
            if (subAtributos[key]) {
              console.log(`✅ Encontrado con key "${key}":`, subAtributos[key]);
            }
          });
        }
        
        setAtributosData(subAtributos);
      }
    } catch (error) {
      console.error('Error al cargar atributos:', error);
    } finally {
      setLoadingAtributos(false);
    }
  };

  const cargarRegimenesLaborales = async () => {
    try {
      setLoadingRegimenes(true);
      const response = await regimenLaboralService.getAll();
      
      if (response.success) {
        setRegimenesLaborales(response.data || []);
      }
    } catch (error) {
      console.error('Error al cargar regímenes laborales:', error);
    } finally {
      setLoadingRegimenes(false);
    }
  };

  const cargarFormulas = async () => {
    try {
      setLoadingFormulas(true);
      const response = await formulaService.obtenerFormulas();
      
      if (response.success && response.data) {
        const formulasData = Array.isArray(response.data.data) ? response.data.data : [];
        setFormulas(formulasData);
        console.log('✅ Fórmulas cargadas:', formulasData.length);
      }
    } catch (error) {
      console.error('❌ Error al cargar fórmulas:', error);
    } finally {
      setLoadingFormulas(false);
    }
  };

  const cargarAfps = async () => {
    try {
      setLoadingAfpsData(true);
      const response = await afpService.obtenerAfps();
      
      if (response.success && response.data) {
        const afpsCompletas = Array.isArray(response.data) ? response.data : [];
        setAfpsData(afpsCompletas);
        console.log('✅ AFPs cargadas:', afpsCompletas.length);
      }
    } catch (error) {
      console.error('❌ Error al cargar AFPs:', error);
    } finally {
      setLoadingAfpsData(false);
    }
  };

  const cargarInformacionGeneral = async () => {
    try {
      setLoadingInformacionGeneral(true);
      const response = await informacionGeneralService.obtenerInformacionActual();
      
      if (response.success && response.data) {
        setInformacionGeneral(response.data);
        console.log('✅ Información general cargada:', response.data);
      }
    } catch (error) {
      console.error('❌ Error al cargar información general:', error);
    } finally {
      setLoadingInformacionGeneral(false);
    }
  };

  const cargarTramosRenta = async () => {
    try {
      setLoadingTramosRenta(true);
      const response = await tramoRentaService.obtenerTramosRenta();
      
      if (response.success && response.data) {
        const tramosData = Array.isArray(response.data) ? response.data : [];
        setTramosRenta(tramosData);
        console.log('✅ Tramos de renta cargados:', tramosData.length);
      }
    } catch (error) {
      console.error('❌ Error al cargar tramos de renta:', error);
    } finally {
      setLoadingTramosRenta(false);
    }
  };

  const cargarConfiguracionRentaQuinta = async () => {
    if (!selectedCompany?.id) return;
    
    try {
      setLoadingConfigRentaQuinta(true);
      const response = await configuracionRentaQuintaService.obtenerConfiguracion(selectedCompany.id);
      
      if (response.success && response.data) {
        setConfiguracionRentaQuinta(response.data);
        console.log('✅ Configuración de renta de quinta cargada:', response.data.activo);
      } else {
        // Si no existe configuración, asumir que está desactivada
        setConfiguracionRentaQuinta({ activo: false });
        console.log('ℹ️ Configuración de renta de quinta no encontrada, asumiendo desactivada');
      }
    } catch (error) {
      console.error('❌ Error al cargar configuración de renta de quinta:', error);
      // En caso de error, asumir que está desactivada
      setConfiguracionRentaQuinta({ activo: false });
    } finally {
      setLoadingConfigRentaQuinta(false);
    }
  };

  /**
   * Reubica conceptos al cambiar Solo interna ↔ Dual para no dejar
   * ingresos de control en la columna PLAME (ni al revés).
   * Dual requiere contratación Planilla (no Interno) para que el motor
   * PLAME calcule ONP/AFP/EsSalud.
   */
  const aplicarCambioTipoPlanilla = (prev, nuevoTipo) => {
    const anterior = prev.tipoPlanilla || 'dual';
    const base = { ...prev, tipoPlanilla: nuevoTipo };

    if (anterior === nuevoTipo) {
      return base;
    }

    const clonarLista = (lista, idOffset = 0) =>
      (lista || []).map((item, index) => ({
        ...item,
        id:
          item.id != null
            ? Number(item.id) + idOffset
            : Date.now() + index + idOffset,
      }));

    // Solo interna → Dual: lo que estaba en "ingresos" era control
    if (anterior === 'solo_interna' && nuevoTipo === 'dual') {
      const ingresosControl =
        (prev.ingresos || []).length > 0
          ? clonarLista(prev.ingresos, 3000)
          : clonarLista(prev.ingresosInternos, 3000);
      return {
        ...base,
        // Interno solo aplica a solo_interna; en dual PLAME necesita Planilla
        tipoContratacion:
          prev.tipoContratacion === 'Interno' ? 'Planilla' : prev.tipoContratacion,
        ingresos: [],
        descuentos: [],
        aportes: [],
        ingresosInternos: ingresosControl,
        descuentosInternos: [],
        aportesInternos: [],
      };
    }

    // Dual → Solo interna: priorizar ingresos de boleta interna
    if (anterior === 'dual' && nuevoTipo === 'solo_interna') {
      const ingresosControl =
        (prev.ingresosInternos || []).length > 0
          ? clonarLista(prev.ingresosInternos)
          : clonarLista(prev.ingresos);
      return {
        ...base,
        ingresos: ingresosControl,
        descuentos: [],
        aportes: [],
        ingresosInternos: [],
        descuentosInternos: [],
        aportesInternos: [],
      };
    }

    return base;
  };

  const regenerarTrasCambioTipoPlanilla = async (formSnapshot, nuevoTipo) => {
    const sueldoBasico = parseFloat(formSnapshot.sueldoBasico) || 0;
    const sueldoInterno = parseFloat(formSnapshot.sueldoInterno) || 0;
    const esConsu = esRegimenConstruccionCivil(
      formSnapshot.regimenLaboral,
      regimenesLaborales
    );
    const puedeGenerar =
      nuevoTipo === 'solo_interna'
        ? sueldoInterno > 0
        : esConsu || sueldoBasico > 0;

    if (!puedeGenerar) {
      console.log(
        'ℹ️ Cambio de tipo de planilla aplicado; Generar pendiente (faltan sueldos)'
      );
      return;
    }

    try {
      const datosCompletos = await prepararDatosParaServicio(null, formSnapshot);
      await ejecutarPipelineCalculos(
        datosCompletos,
        'cambio_tipo_planilla',
        { tipoPlanilla: nuevoTipo }
      );
    } catch (error) {
      console.error('❌ Error al regenerar tras cambio de tipo de planilla:', error);
      alert(
        `Se cambió el tipo de planilla, pero falló el recálculo: ${
          error.message || error
        }. Use Generar.`
      );
    }
  };

  const handleTipoPlanillaChange = (nuevoTipo) => {
    const anterior = formData.tipoPlanilla || 'dual';
    if (nuevoTipo === anterior) return;

    const snapshot = aplicarCambioTipoPlanilla(formData, nuevoTipo);
    setFormData(snapshot);

    if (errors.tipoPlanilla) {
      setErrors((prev) => ({ ...prev, tipoPlanilla: '' }));
    }

    regenerarTrasCambioTipoPlanilla(snapshot, nuevoTipo);
  };

  const handleInputChange = (field, value) => {
    // Interno + planilla alternativa: forzar solo_interna con migración de conceptos
    if (
      field === 'tipoContratacion' &&
      value === 'Interno' &&
      planillaAlternativaActiva
    ) {
      const base = { ...formData, tipoContratacion: value };
      const debeMigrar = (formData.tipoPlanilla || 'dual') !== 'solo_interna';
      const snapshot = debeMigrar
        ? aplicarCambioTipoPlanilla(base, 'solo_interna')
        : { ...base, tipoPlanilla: 'solo_interna' };
      setFormData(snapshot);
      if (errors.tipoContratacion || errors.tipoPlanilla) {
        setErrors((prev) => ({
          ...prev,
          tipoContratacion: '',
          tipoPlanilla: '',
        }));
      }
      if (debeMigrar) {
        regenerarTrasCambioTipoPlanilla(snapshot, 'solo_interna');
      }
      return;
    }

    setFormData(prev => {
      const newData = {
        ...prev,
        [field]: value
      };

      // Si se cambia a ONP, limpiar campos de AFP
      if (field === 'sistemaPensionario' && value === 'ONP') {
        newData.afp = '';
        newData.afp_id = null;
        newData.cuspp = '';
        newData.tipoAfp = 'Flujo'; // Mantener valor por defecto
      }

      // Si se desactiva el bono, limpiar el monto
      if (field === 'tieneBono' && !value) {
        newData.montoBono = '';
      }

      // Al cambiar el régimen laboral, actualizar el id (en edición el backend recibe regimen_laboral_id)
      if (field === 'regimenLaboral') {
        const regimen = regimenesLaborales.find(r => r.nombre === value);
        newData.regimenLaboralId = regimen ? regimen.id : null;
      }

      return newData;
    });
    
    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }

    // Si es el campo de número de documento y es DNI, consultar automáticamente
    if (field === 'numeroDocumento' && formData.tipoDocumento === 'DNI') {
      consultarDNIAutomatico(value);
    }
  };

  // Función para consultar DNI automáticamente usando MIGO API
  const consultarDNIAutomatico = async (dni) => {
    // Validar que el DNI tenga 8 dígitos
    if (!dni || dni.length !== 8 || !/^\d{8}$/.test(dni)) {
      return; // No hacer consulta si no es un DNI válido
    }

    // Verificar que el token esté configurado
    if (!tokenMigo) {
      console.log('⚠️ Token de MIGO no configurado para consulta automática');
      return;
    }

    setConsultandoDNI(true);
    
    try {
      // Configurar el token en el servicio
      migoService.setToken(tokenMigo);
      
      console.log('🔍 Iniciando consulta automática de DNI:', dni);
      const response = await migoService.consultarDNI(dni);
      
      if (response.success && response.data.nombre) {
        console.log('✅ DNI consultado exitosamente:', response.data.nombre);
        
        // Llenar automáticamente el campo de nombre completo
        setFormData(prev => ({
          ...prev,
          nombreCompleto: response.data.nombre
        }));
        
        // Limpiar error de nombre completo si existía
        if (errors.nombreCompleto) {
          setErrors(prev => ({
            ...prev,
            nombreCompleto: ''
          }));
        }
        
        console.log('✅ Nombre completado automáticamente');
        
      } else {
        console.log('⚠️ No se pudo obtener el nombre para el DNI:', dni);
        console.log('Error:', response.error);
      }
      
    } catch (error) {
      console.error('❌ Error en consulta automática de DNI:', error);
    } finally {
      setConsultandoDNI(false);
    }
  };

  const handleDiaTrabajoChange = (dia) => {
    setFormData(prev => ({
      ...prev,
      diasTrabajo: prev.diasTrabajo.includes(dia)
        ? prev.diasTrabajo.filter(d => d !== dia)
        : [...prev.diasTrabajo, dia]
    }));
  };

  // Funciones para manejar conceptos dinámicos
  const agregarConcepto = (tipo) => {
    setBuscadorVisible(true);
    setTipoConceptoActual(tipo);
    setTerminoBusqueda('');
    setResultadosBusqueda([]); // Limpiar resultados previos
    
    // Cargar códigos PLAME si no están cargados, pero no mostrar resultados automáticamente
    if (codigosPlame.length === 0) {
      cargarCodigosPlame();
    }
  };

  // Cargar códigos PLAME
  const cargarCodigosPlame = async () => {
    try {
      setLoadingPlame(true);
      const response = await plameConfiguracionService.obtenerConfiguraciones({ per_page: 1000 });
      
      if (response.success) {
        const codigos = response.data.data.map(config => ({
          id: config.id,
          codigo: config.codigo_plame,
          descripcion: config.descripcion,
          clasificacion: config.clasificacion,
          id_tipo: config.clasificacion?.id_tipo || null,
          afectaciones: {
            essalud_regular: config.essalud_regular,
            essalud_cbssp_seg: config.essalud_cbssp_seg,
            essalud_agrario: config.essalud_agrario,
            essalud_sctr: config.essalud_sctr,
            impuesto_extraord_solid: config.impuesto_extraord_solid,
            fondo_derechos_artista: config.fondo_derechos_artista,
            senati: config.senati,
            sistema_nacional_19990: config.sistema_nacional_19990,
            sistema_privado_pension: config.sistema_privado_pension,
            fondo_compl_jubil: config.fondo_compl_jubil,
            reg_esp_pensiones_pesq: config.reg_esp_pensiones_pesq,
            renta_5ta_categoria: config.renta_5ta_categoria,
            essalud_regular_pension: config.essalud_regular_pension,
            contrib_solidaria_asist: config.contrib_solidaria_asist
          }
        }));
        setCodigosPlame(codigos);
      }
    } catch (error) {
      console.error('Error al cargar códigos PLAME:', error);
    } finally {
      setLoadingPlame(false);
    }
  };

  // Buscar códigos PLAME
  const buscarCodigosPlame = (termino) => {
    setTerminoBusqueda(termino);
    
    // Mapear tipos de concepto a id_tipo de clasificación
    const clasificacionMap = {
      'ingresos': 1,
      'ingresosInternos': 1,
      'descuentos': 2,  
      'descuentosInternos': 2,
      'aportes': 3,
      'aportesInternos': 3,
    };
    
    const idTipoFiltro = clasificacionMap[tipoConceptoActual];
    
    if (!termino.trim()) {
      // Si no hay término, no mostrar resultados
      setResultadosBusqueda([]);
      return;
    }

    // Filtrar por término de búsqueda Y por tipo de clasificación
    const resultados = codigosPlame.filter(codigo => 
      codigo.id_tipo === idTipoFiltro &&
      (codigo.codigo.toLowerCase().includes(termino.toLowerCase()) ||
       codigo.descripcion.toLowerCase().includes(termino.toLowerCase()))
    ).slice(0, 10);

    setResultadosBusqueda(resultados);
  };

  // Función para buscar fórmulas disponibles para un concepto PLAME
  const buscarFormulasDisponibles = async (codigoPlame) => {
    try {
      console.log('🔍 Buscando fórmulas para código PLAME:', codigoPlame);
      
      // Obtener régimen laboral seleccionado
      const regimenSeleccionado = regimenesLaborales.find(r => r.nombre === formData.regimenLaboral);
      
      if (!regimenSeleccionado) {
        console.log('⚠️ No hay régimen laboral seleccionado');
        setFormulasDisponibles([]);
        return;
      }

      // Filtrar fórmulas por código PLAME y régimen laboral
      const formulasParaCodigo = formulas.filter(formula => 
        formula.codigo === codigoPlame && 
        formula.id_tipo === regimenSeleccionado.id
      );

      console.log('✅ Fórmulas encontradas:', formulasParaCodigo);
      setFormulasDisponibles(formulasParaCodigo);
      
      // Si hay fórmulas, seleccionar la primera automáticamente
      if (formulasParaCodigo.length > 0) {
        const primeraFormula = formulasParaCodigo[0];
        setFormulaSeleccionada(primeraFormula);
        await calcularFormula(primeraFormula);
      } else {
        setFormulaSeleccionada(null);
        setCalculoFormula(null);
      }
      
    } catch (error) {
      console.error('❌ Error al buscar fórmulas:', error);
      setFormulasDisponibles([]);
    }
  };

  // Función para calcular el valor de una fórmula
  const calcularFormula = async (formula) => {
    try {
      console.log('🧮 Calculando fórmula:', formula.formula);
      
      let formulaParaCalcular = formula.formula;
      let resultado = null;
      let variables = {};

      // Obtener valores necesarios para el cálculo
      const sueldoBasico =
        planillaAlternativaActiva &&
        (formData.tipoPlanilla === 'solo_interna' ||
          tipoConceptoActual === 'ingresosInternos' ||
          tipoConceptoActual === 'descuentosInternos' ||
          tipoConceptoActual === 'aportesInternos')
          ? (parseFloat(formData.sueldoInterno) || 0)
          : (parseFloat(formData.sueldoBasico) || 0);
      const sueldoMinimo = informacionGeneral?.sueldo_minimo?.monto || 1025;
      const uit = informacionGeneral?.uit?.monto || 5150; // Valor por defecto UIT 2024
      
      variables.R = sueldoBasico;
      variables.M = sueldoMinimo;
      variables.U = uit;

      // Reemplazar variables básicas
      formulaParaCalcular = formulaParaCalcular.replace(/\bR\b/g, sueldoBasico);
      formulaParaCalcular = formulaParaCalcular.replace(/\bM\b/g, sueldoMinimo);
      formulaParaCalcular = formulaParaCalcular.replace(/\bU\b/g, uit);
      
      // Para fórmulas con porcentajes de AFP
      if (formData.sistemaPensionario === 'AFP' && formData.afp) {
        const afpSeleccionada = afpsData.find(afp => afp.nombre === `AFP ${formData.afp}`);
        if (afpSeleccionada) {
          let porcentajeAfp;
          if (formData.tipoAfp === 'Flujo') {
            porcentajeAfp = afpSeleccionada.comision_fija || 0;
          } else {
            porcentajeAfp = afpSeleccionada.comision_variable || 0;
          }
          
          variables.A = porcentajeAfp;
          formulaParaCalcular = formulaParaCalcular.replace(/\bA\b/g, porcentajeAfp / 100);
        }
      }

      // Calcular base de cálculo para conceptos que dependen de ingresos
      let baseCalculoIngresos = 0;
      if (formData.ingresos && formData.ingresos.length > 0) {
        baseCalculoIngresos = formData.ingresos.reduce((total, ingreso) => {
          return total + (parseFloat(ingreso.monto) || 0);
        }, 0);
      }
      
      // Si la fórmula usa BASE_INGRESOS, reemplazarla
      if (formulaParaCalcular.includes('BASE_INGRESOS')) {
        variables.BASE_INGRESOS = baseCalculoIngresos;
        formulaParaCalcular = formulaParaCalcular.replace(/BASE_INGRESOS/g, baseCalculoIngresos);
      }

      // Reemplazar porcentajes directos (ej: 13%, 9%, etc.)
      formulaParaCalcular = formulaParaCalcular.replace(/(\d+(?:\.\d+)?)%/g, '($1/100)');
      
      // Manejar fórmulas especiales
      if (formulaParaCalcular.includes('DIAS_TRABAJADOS') || formulaParaCalcular.includes('MESES')) {
        resultado = 'Requiere datos de tiempo trabajado';
      } else if (formulaParaCalcular.includes('UTILIDAD_EMPRESA')) {
        resultado = 'Requiere información de utilidades';
      } else if (formulaParaCalcular.includes('HE25') || formulaParaCalcular.includes('HE35') || formulaParaCalcular.includes('HN')) {
        resultado = 'Requiere horas extras/nocturnas';
      } else {
        try {
          // Evaluar la fórmula (solo si contiene operaciones matemáticas básicas)
          const formulaLimpia = formulaParaCalcular.replace(/\s/g, '');
          if (/^[0-9+\-*/.() ]+$/.test(formulaLimpia)) {
            resultado = eval(formulaLimpia);
            resultado = parseFloat(resultado.toFixed(2));
          } else {
            resultado = 'Fórmula compleja - requiere datos adicionales';
          }
        } catch (evalError) {
          console.log('⚠️ No se pudo evaluar automáticamente:', evalError);
          resultado = 'Requiere cálculo manual';
        }
      }

      const calculoInfo = {
        formulaOriginal: formula.formula,
        formulaReemplazada: formulaParaCalcular,
        resultado: resultado,
        variables: variables,
        descripcion: formula.plame_configuracion?.descripcion || 'Sin descripción'
      };

      console.log('📊 Resultado del cálculo:', calculoInfo);
      setCalculoFormula(calculoInfo);

      // Si el resultado es numérico y mayor que 0, actualizar el monto modal
      if (typeof resultado === 'number' && resultado > 0) {
        setMontoModal(resultado.toString());
      }

    } catch (error) {
      console.error('❌ Error al calcular fórmula:', error);
      setCalculoFormula({
        formulaOriginal: formula.formula,
        formulaReemplazada: 'Error en cálculo',
        resultado: 'Error',
        variables: {},
        descripcion: 'Error en el cálculo'
      });
    }
  };

  // Seleccionar concepto PLAME para agregar monto
  const seleccionarConceptoPlame = async (codigoPlame) => {
    setConceptoSeleccionado(codigoPlame);
    setMontoModal('');
    setMostrarFormulas(true);
    
    // Buscar fórmulas disponibles para este concepto
    await buscarFormulasDisponibles(codigoPlame.codigo);
    
    // No cerrar el modal, solo mostrar el campo de monto y fórmulas
  };

  // Función para seleccionar una fórmula específica
  const seleccionarFormula = async (formula) => {
    setFormulaSeleccionada(formula);
    await calcularFormula(formula);
  };

  // Confirmar y agregar concepto con monto
  const confirmarConceptoConMonto = async () => {
    if (!conceptoSeleccionado || !montoModal || parseFloat(montoModal) <= 0) {
      alert('❌ Debe ingresar un monto válido mayor a 0');
      return;
    }

    // id de lista solo para React; el ID PLAME real va en plame_configuracion_id
    // (antes se usaba max(ids)+1 y al guardar en edición ese número se confundía
    // con plame_configuracion.id — p.ej. 248 = aportación voluntaria 0609)
    const nuevoId = `ui-${conceptoSeleccionado.id}-${Date.now()}`;
    
    const nuevoConcepto = {
      id: nuevoId,
      plame_configuracion_id: Number(conceptoSeleccionado.id),
      codigoPlame: conceptoSeleccionado.codigo,
      concepto: conceptoSeleccionado.descripcion,
      monto: parseFloat(montoModal),
      afectaciones: conceptoSeleccionado.afectaciones,
      obligatorio: false
    };

    // Crear los conceptos actualizados ANTES de actualizar el estado
    const conceptosActualizados = [...(formData[tipoConceptoActual] || []), nuevoConcepto];
  
    // Agregar al formulario
    setFormData(prev => ({
      ...prev,
      [tipoConceptoActual]: conceptosActualizados
    }));

    // Ejecutar cálculo automático CON los conceptos actualizados
    console.log('🚀 Ejecutando cálculo automático después de agregar concepto...');
    console.log('📝 Nuevo concepto añadido:', nuevoConcepto);
    console.log('📋 Tipo de concepto:', tipoConceptoActual);
    console.log('🔢 Total conceptos después de añadir:', conceptosActualizados.length);
    await ejecutarCalculoAutomaticoConConceptos(tipoConceptoActual, conceptosActualizados);

    // Cerrar modal y limpiar datos
    setBuscadorVisible(false);
    setTerminoBusqueda('');
    setResultadosBusqueda([]);
    setTipoConceptoActual('');
    setConceptoSeleccionado(null);
    setMontoModal('');
    setFormulasDisponibles([]);
    setFormulaSeleccionada(null);
    setCalculoFormula(null);
    setMostrarFormulas(false);
  };

  // Función para ejecutar cálculo automático CON conceptos específicos
  const ejecutarCalculoAutomaticoConConceptos = async (tipoConcepto, conceptosActualizados) => {
    try {
      // Boleta interna: agregar/editar ahí NO recalcula ni toca descuentos/aportes (ni PLAME ni internos)
      if (
        tipoConcepto === 'ingresosInternos' ||
        tipoConcepto === 'descuentosInternos' ||
        tipoConcepto === 'aportesInternos'
      ) {
        console.log('ℹ️ Cambio en boleta interna: sin recálculo de descuentos/aportes');
        return;
      }

      // Cambio en PLAME → recalcula PLAME y sincroniza desc/aportes también en la interna
      const conceptosEspecificos = {
        ingresos: tipoConcepto === 'ingresos' ? conceptosActualizados : (formData.ingresos || []),
        descuentos: tipoConcepto === 'descuentos' ? conceptosActualizados : (formData.descuentos || []),
        aportes: tipoConcepto === 'aportes' ? conceptosActualizados : (formData.aportes || []),
        ingresosInternos: formData.ingresosInternos || [],
        descuentosInternos: formData.descuentosInternos || [],
        aportesInternos: formData.aportesInternos || [],
      };

      const datosCompletos = await prepararDatosParaServicio(conceptosEspecificos);
      await ejecutarPipelineCalculos(datosCompletos, 'agregar_concepto_automatico');
    } catch (error) {
      console.error('❌ Error al ejecutar cálculo automático:', error);
    }
  };

  // Función para ejecutar cálculo automático (para ediciones de conceptos existentes)
  const ejecutarCalculoAutomatico = async () => {
    try {
      const datosCompletos = await prepararDatosParaServicio();
      await ejecutarPipelineCalculos(datosCompletos, 'agregar_concepto_automatico');
    } catch (error) {
      console.error('❌ Error al ejecutar cálculo automático:', error);
    }
  };

  const mapearConceptosServicioAVista = (items, idOffset = 0) => {
    const arr = Array.isArray(items) ? items : (items ? [items] : []);
    return arr.map((item, index) => {
      const plameId = item.id_concepto?.id ?? null;
      const codigo =
        item.id_concepto?.codigo ||
        item.id_concepto?.codigo_plame ||
        'N/A';
      return {
        id: plameId != null ? plameId : Date.now() + index + idOffset,
        plame_configuracion_id: plameId != null ? Number(plameId) : null,
        concepto: item.id_concepto?.descripcion || 'Sin descripción',
        monto: Number(item.valor) || 0,
        codigoPlame: codigo,
        descripcion: item.id_concepto?.descripcion || 'Sin descripción',
      };
    });
  };

  const listasConceptosDesdePipeline = (pipe, fd) => {
    if (!pipe?.resultadoPlame?.data && !pipe?.resultadoInterna?.data) {
      return null;
    }
    const tipo = fd.tipoPlanilla || 'dual';
    const esSoloInterna = planillaAlternativaActiva && tipo === 'solo_interna';
    const esDual = planillaAlternativaActiva && tipo === 'dual';

    if (esSoloInterna && pipe.resultadoInterna?.data) {
      return {
        ingresos: mapearConceptosServicioAVista(pipe.resultadoInterna.data.dataIngresos),
        descuentos: [],
        aportes: [],
        ingresosInternos: [],
        descuentosInternos: [],
        aportesInternos: [],
      };
    }

    const listas = {
      ingresos: mapearConceptosServicioAVista(pipe.resultadoPlame?.data?.dataIngresos),
      descuentos: mapearConceptosServicioAVista(
        pipe.resultadoPlame?.data?.dataDescuentos,
        1000
      ),
      aportes: mapearConceptosServicioAVista(pipe.resultadoPlame?.data?.dataAportes, 2000),
      ingresosInternos: [],
      descuentosInternos: [],
      aportesInternos: [],
    };

    if (esDual && pipe.resultadoInterna?.data) {
      listas.ingresosInternos = mapearConceptosServicioAVista(
        pipe.resultadoInterna.data.dataIngresos,
        3000
      );
      listas.descuentosInternos = mapearConceptosServicioAVista(
        pipe.resultadoInterna.data.dataDescuentos,
        4000
      );
      listas.aportesInternos = mapearConceptosServicioAVista(
        pipe.resultadoInterna.data.dataAportes,
        5000
      );
    }

    return listas;
  };

  const recalcularRemuneracionConsu = async (origen, formOverride = null) => {
    const fd = formOverride || formData;
    if (!esRegimenConstruccionCivil(fd.regimenLaboral, regimenesLaborales)) {
      return null;
    }
    if (!validarCamposGenerar(fd)) {
      return null;
    }
    if (consuRecalcEnCursoRef.current) {
      return null;
    }
    consuRecalcEnCursoRef.current = true;
    try {
      const datosCompletos = await prepararDatosParaServicio(null, fd);
      return await ejecutarPipelineCalculos(datosCompletos, origen, {
        tipoPlanilla: fd.tipoPlanilla,
      });
    } catch (error) {
      console.error('❌ Error al recalcular CONSU:', error);
      return null;
    } finally {
      consuRecalcEnCursoRef.current = false;
    }
  };

  /**
   * Pipeline: PLAME (si aplica) → boleta interna (si planilla alternativa).
   * - dual: PLAME calcula ONP/AFP/EsSalud; la interna copia esos mismos desc/aportes.
   * - Cambios en PLAME afectan ambos; cambios en interna no tocan descuentos.
   * - solo_interna: solo ingresos, sin descuentos ni aportes.
   */
  const ejecutarPipelineCalculos = async (datosCompletos, origen, opciones = {}) => {
    const tipoPlanilla =
      opciones.tipoPlanilla ??
      datosCompletos?.datosSalariales?.tipoPlanilla ??
      formData.tipoPlanilla;
    const esSoloInterna = planillaAlternativaActiva && tipoPlanilla === 'solo_interna';
    const esDual = planillaAlternativaActiva && tipoPlanilla === 'dual';
    const debeCorrerPlame = !planillaAlternativaActiva || esDual;
    const debeCorrerInterna = planillaAlternativaActiva;
    // En recálculo por Agregar/editar PLAME: no pisar ingresos internos ya cargados
    const preservarIngresosInternos =
      String(origen || '').includes('agregar_concepto') ||
      String(origen || '').includes('automatico');

    let resultadoPlame = null;

    if (debeCorrerPlame) {
      console.log('🚀 Ejecutando motor PLAME...', origen);
      resultadoPlame = await calculosBoletaService.generarCalculos(datosCompletos, origen);
      if (!resultadoPlame.success) {
        console.error('❌ Error en motor PLAME:', resultadoPlame.error);
        alert(`Error en el servicio PLAME: ${resultadoPlame.error}`);
        return null;
      }
    }

    let resultadoInterna = null;
    if (debeCorrerInterna) {
      const datosInterna = {
        ...datosCompletos,
        datosSalariales: {
          ...datosCompletos.datosSalariales,
          sueldoInterno: Number(datosCompletos.datosSalariales?.sueldoInterno) || 0,
        },
      };
      console.log('🚀 Ejecutando motor boleta interna (post-PLAME)...', origen);
      resultadoInterna = await calculosBoletaInternaService.generarCalculos(
        datosInterna,
        resultadoPlame,
        `${origen}_interna`
      );
      if (!resultadoInterna.success) {
        console.error('❌ Error en motor interna:', resultadoInterna.error);
        alert(`Error en el servicio interno: ${resultadoInterna.error}`);
        return null;
      }
    }

    await procesarResultadosPipeline({
      resultadoPlame,
      resultadoInterna,
      esSoloInterna,
      esDual,
      preservarIngresosInternos,
    });

    return { resultadoPlame, resultadoInterna };
  };

  const procesarResultadosPipeline = async ({
    resultadoPlame,
    resultadoInterna,
    esSoloInterna,
    esDual,
    preservarIngresosInternos = false,
  }) => {
    if (esSoloInterna && resultadoInterna?.data) {
      setFormData((prev) => ({
        ...prev,
        ingresos: mapearConceptosServicioAVista(resultadoInterna.data.dataIngresos),
        descuentos: [],
        aportes: [],
        ingresosInternos: [],
        descuentosInternos: [],
        aportesInternos: [],
      }));
      setActiveTab('remuneracion');
      console.log('✅ Solo interna: ingresos de control sin descuentos/aportes');
      return;
    }

    if (esDual) {
      const descuentosInternos = mapearConceptosServicioAVista(
        resultadoInterna?.data?.dataDescuentos,
        4000
      );
      const aportesInternos = mapearConceptosServicioAVista(
        resultadoInterna?.data?.dataAportes,
        5000
      );

      setFormData((prev) => {
        const updates = {
          // Siempre sincronizar desc/aportes internos = PLAME (ONP/AFP, EsSalud, minera)
          descuentosInternos,
          aportesInternos,
        };

        if (!preservarIngresosInternos) {
          updates.ingresosInternos = mapearConceptosServicioAVista(
            resultadoInterna?.data?.dataIngresos,
            3000
          );
        }
        // Si preservar: se mantienen prev.ingresosInternos (cambios en PLAME no los borran)

        if (resultadoPlame?.data) {
          updates.ingresos = mapearConceptosServicioAVista(resultadoPlame.data.dataIngresos);
          updates.descuentos = mapearConceptosServicioAVista(
            resultadoPlame.data.dataDescuentos,
            1000
          );
          updates.aportes = mapearConceptosServicioAVista(resultadoPlame.data.dataAportes, 2000);
        }

        return { ...prev, ...updates };
      });
      setActiveTab('remuneracion');
      console.log(
        '✅ Dual: PLAME actualizado; desc/aportes internos sincronizados desde PLAME',
        { preservarIngresosInternos }
      );
      return;
    }

    // Sin planilla alternativa: solo PLAME
    if (resultadoPlame) {
      await procesarResultadosServicio(resultadoPlame);
    }
  };

  // Función auxiliar UNIFICADA para preparar datos para el servicio
  const prepararDatosParaServicio = async (conceptosEspecificos = null, formOverride = null) => {
    const fd = formOverride || formData;
    // Cargar datos si no están disponibles
    let conceptosPlameActuales = codigosPlame.length > 0 ? codigosPlame : [];
    let formulasActuales = Array.isArray(formulas) && formulas.length > 0 ? formulas : [];
    let afpsActuales = Array.isArray(afpsData) && afpsData.length > 0 ? afpsData : [];
    let informacionActual = informacionGeneral && Object.keys(informacionGeneral).length > 0 ? informacionGeneral : {};
    let tramosActuales = Array.isArray(tramosRenta) && tramosRenta.length > 0 ? tramosRenta : [];
    let configRentaQuintaActual = configuracionRentaQuinta || { activo: false };

    // Cargar datos faltantes si es necesario
    if (conceptosPlameActuales.length === 0) {
      const response = await plameConfiguracionService.obtenerConfiguraciones({ per_page: 1000 });
      if (response.success) {
        conceptosPlameActuales = response.data.data.map(config => ({
          id: config.id,
          codigo: config.codigo_plame,
          descripcion: config.descripcion,
          clasificacion: config.clasificacion,
          id_tipo: config.clasificacion?.id_tipo || null,
          afectaciones: {
            essalud_regular: config.essalud_regular,
            essalud_cbssp_seg: config.essalud_cbssp_seg,
            essalud_agrario: config.essalud_agrario,
            essalud_sctr: config.essalud_sctr,
            impuesto_extraord_solid: config.impuesto_extraord_solid,
            fondo_derechos_artista: config.fondo_derechos_artista,
            senati: config.senati,
            sistema_nacional_19990: config.sistema_nacional_19990,
            sistema_privado_pension: config.sistema_privado_pension,
            fondo_compl_jubil: config.fondo_compl_jubil,
            reg_esp_pensiones_pesq: config.reg_esp_pensiones_pesq,
            renta_5ta_categoria: config.renta_5ta_categoria,
            essalud_regular_pension: config.essalud_regular_pension,
            contrib_solidaria_asist: config.contrib_solidaria_asist
          }
        }));
        setCodigosPlame(conceptosPlameActuales);
      }
    }

    // Cargar configuración de renta de quinta si no está disponible
    if (!configRentaQuintaActual || configRentaQuintaActual === null) {
      try {
        const response = await configuracionRentaQuintaService.obtenerConfiguracion(selectedCompany.id);
        if (response.success && response.data) {
          configRentaQuintaActual = response.data;
          setConfiguracionRentaQuinta(configRentaQuintaActual);
        } else {
          configRentaQuintaActual = { activo: false };
        }
      } catch (error) {
        console.error('❌ Error al cargar configuración de renta de quinta:', error);
        configRentaQuintaActual = { activo: false };
      }
    }

    // Modo edición / recálculo automático: asegurar fórmulas y RMV (0314 agrario usa M)
    if (!formulasActuales.length) {
      try {
        const response = await formulaService.obtenerFormulas();
        if (response.success && response.data?.data) {
          formulasActuales = Array.isArray(response.data.data) ? response.data.data : [];
          setFormulas(formulasActuales);
        }
      } catch (error) {
        console.error('❌ Error al cargar fórmulas (prepararDatosParaServicio):', error);
      }
    }
    const faltaRMV =
      informacionActual?.sueldo_minimo?.monto === undefined ||
      informacionActual?.sueldo_minimo?.monto === null;
    if (faltaRMV) {
      try {
        const response = await informacionGeneralService.obtenerInformacionActual();
        if (response.success && response.data) {
          informacionActual =
            informacionActual && Object.keys(informacionActual).length > 0
              ? { ...informacionActual, ...response.data }
              : response.data;
          setInformacionGeneral(informacionActual);
        }
      } catch (error) {
        console.error('❌ Error al cargar información general / RMV (prepararDatosParaServicio):', error);
      }
    }

    const datosEmpresa = selectedCompany;
    const datosAPIs = {
      regimenesLaborales: regimenesLaborales,
      regimenSeleccionado: regimenesLaborales.find(r => r.nombre === fd.regimenLaboral),
      conceptosPlame: conceptosPlameActuales,
      conceptosIngresos: conceptosPlameActuales.filter(c => c.id_tipo === 1),
      conceptosDescuentos: conceptosPlameActuales.filter(c => c.id_tipo === 2),
      conceptosAportes: conceptosPlameActuales.filter(c => c.id_tipo === 3),
      formulas: formulasActuales,
      formulasIngresos: Array.isArray(formulasActuales) ? formulasActuales.filter(f => f.id_tipo === 1) : [],
      formulasDescuentos: Array.isArray(formulasActuales) ? formulasActuales.filter(f => f.id_tipo === 2) : [],
      formulasAportes: Array.isArray(formulasActuales) ? formulasActuales.filter(f => f.id_tipo === 3) : [],
      afps: afpsActuales,
      uit: informacionActual.uit || null,
      sueldoMinimo: informacionActual.sueldo_minimo || null,
      informacionGeneral: informacionActual,
      tramosRenta: tramosActuales,
      configuracionRentaQuinta: configRentaQuintaActual,
      rentaQuintaActivada: configRentaQuintaActual.activo || false,
      atributosData: atributosData,
      construccionCivil: esRegimenConstruccionCivil(fd.regimenLaboral, regimenesLaborales)
        ? { ficha: fichaConsu, parametros: parametrosConsu }
        : undefined,
    };

    const datosSalariales = {
      // PLAME siempre usa sueldo declarado; interna usa sueldoInterno en su propio service
      sueldoBasico: parseFloat(fd.sueldoBasico) || 0,
      sueldoInterno: parseFloat(fd.sueldoInterno) || 0,
      tipoPlanilla: fd.tipoPlanilla || null,
      sistemaPensionario: fd.sistemaPensionario,
      afp: fd.afp,
      tipoAfp: fd.tipoAfp,
      cuspp: fd.cuspp,
      regimenLaboral: fd.regimenLaboral,
      asignacionFamiliar: fd.asignacionFamiliar,
      tieneBono: fd.tieneBono,
      montoBono: fd.tieneBono ? (parseFloat(fd.montoBono) || 0) : 0,
      esBoletaLiquidada: fd.esBoletaLiquidada,
      tipoContratacion: fd.tipoContratacion
    };

    // ✅ USAR CONCEPTOS ESPECÍFICOS SI SE PROPORCIONAN, O DEL form (override o estado)
    const conceptosUsuario = conceptosEspecificos || {
      ingresos: fd.ingresos || [],
      descuentos: fd.descuentos || [],
      aportes: fd.aportes || [],
      ingresosInternos: fd.ingresosInternos || [],
      descuentosInternos: fd.descuentosInternos || [],
      aportesInternos: fd.aportesInternos || [],
    };

    console.log('📍 Conceptos Usuario enviados al servicio:', conceptosUsuario);

    const datosEmpleado = {
      nombres: fd.nombres,
      apellidos: fd.apellidos,
      numeroDocumento: fd.numeroDocumento,
      tipoDocumento: fd.tipoDocumento,
      fechaNacimiento: fd.fechaNacimiento,
      fechaIngreso: fd.fechaIngreso,
      cargo: fd.cargo,
      estado: fd.estado,
      // Configuraciones adicionales
      asignacionFamiliar: fd.asignacionFamiliar,
      tieneBono: fd.tieneBono,
      montoBono: fd.tieneBono ? (parseFloat(fd.montoBono) || 0) : 0,
      esBoletaLiquidada: fd.esBoletaLiquidada
    };

    return {
      datosEmpresa,
      datosAPIs,
      datosSalariales,
      conceptosUsuario,
      datosEmpleado
    };
  };

  // Función auxiliar para procesar resultados del servicio
  const procesarResultadosServicio = async (resultadoCalculos) => {
    // Procesar ingresos
    if (resultadoCalculos.data.dataIngresos) {
      let datosIngresos = Array.isArray(resultadoCalculos.data.dataIngresos) 
        ? resultadoCalculos.data.dataIngresos 
        : [resultadoCalculos.data.dataIngresos];

      const ingresosParaVista = datosIngresos.map((item, index) => ({
        id: item.id_concepto?.id || Date.now() + index,
        plame_configuracion_id: item.id_concepto?.id ?? null,
        concepto: item.id_concepto?.descripcion || 'Sin descripción',
        monto: Number(item.valor) || 0,
        codigoPlame: item.id_concepto?.codigo_plame || item.id_concepto?.codigo || 'N/A',
        descripcion: item.id_concepto?.descripcion || 'Sin descripción',
      }));

      setFormData(prev => ({
        ...prev,
        ingresos: [...ingresosParaVista]
      }));
    }

    // Procesar descuentos
    if (resultadoCalculos.data.dataDescuentos) {
      let datosDescuentos = Array.isArray(resultadoCalculos.data.dataDescuentos) 
        ? resultadoCalculos.data.dataDescuentos 
        : [resultadoCalculos.data.dataDescuentos];

      const descuentosParaVista = datosDescuentos.map((item, index) => ({
        id: item.id_concepto?.id || Date.now() + index + 1000,
        plame_configuracion_id: item.id_concepto?.id ?? null,
        concepto: item.id_concepto?.descripcion || 'Sin descripción',
        monto: Number(item.valor) || 0,
        codigoPlame: item.id_concepto?.codigo_plame || item.id_concepto?.codigo || 'N/A',
        descripcion: item.id_concepto?.descripcion || 'Sin descripción',
      }));

      setFormData(prev => ({
        ...prev,
        descuentos: [...descuentosParaVista]
      }));
    }

    // Procesar aportes
    if (resultadoCalculos.data.dataAportes) {
      let datosAportes = Array.isArray(resultadoCalculos.data.dataAportes) 
        ? resultadoCalculos.data.dataAportes 
        : [resultadoCalculos.data.dataAportes];

      const aportesParaVista = datosAportes.map((item, index) => ({
        id: item.id_concepto?.id || Date.now() + index + 2000,
        plame_configuracion_id: item.id_concepto?.id ?? null,
        concepto: item.id_concepto?.descripcion || 'Sin descripción',
        monto: Number(item.valor) || 0,
        codigoPlame: item.id_concepto?.codigo_plame || item.id_concepto?.codigo || 'N/A',
        descripcion: item.id_concepto?.descripcion || 'Sin descripción',
      }));

      setFormData(prev => ({
        ...prev,
        aportes: [...aportesParaVista]
      }));
    }

    // Cambiar automáticamente a la pestaña de remuneración
    setActiveTab('remuneracion');
  };

  const eliminarConcepto = async (tipo, id) => {
    // Obtener el concepto que se va a eliminar para logging
    const conceptoAEliminar = formData[tipo]?.find(item => item.id === id);
    
    // Crear array sin el concepto eliminado
    const conceptosActualizados = formData[tipo].filter(item => item.id !== id);
    
    // Actualizar el estado
    setFormData(prev => ({
      ...prev,
      [tipo]: conceptosActualizados
    }));

    // Logs para seguimiento
    console.log('🗑️ Eliminando concepto:', conceptoAEliminar?.concepto || 'Concepto no encontrado');
    console.log('📋 Tipo:', tipo);
    console.log('🔢 Conceptos restantes:', conceptosActualizados.length);

    // Ejecutar cálculo automático CON los conceptos actualizados (sin el eliminado)
    console.log('🚀 Ejecutando cálculo automático después de eliminar concepto...');
    await ejecutarCalculoAutomaticoConConceptos(tipo, conceptosActualizados);
  };

  // Función wrapper para eliminar conceptos de forma segura en el JSX
  const handleEliminarConcepto = (tipo, id) => {
    eliminarConcepto(tipo, id).catch(error => {
      console.error('❌ Error al eliminar concepto y ejecutar cálculos:', error);
    });
  };

  // Funciones para manejar edición de conceptos individuales
  const iniciarEdicionConcepto = (tipo, index) => {
    const key = `${tipo}_${index}`;
    setEditandoConcepto(prev => ({
      ...prev,
      [key]: true
    }));
  };

  const guardarCambiosConcepto = async (tipo, index) => {
    const key = `${tipo}_${index}`;
    const conceptos = formData[tipo] || [];
    const concepto = conceptos[index];
    
    // Validar que el monto sea válido
    if (!concepto.monto || parseFloat(concepto.monto) < 0) {
      alert('❌ El monto debe ser mayor o igual a 0');
      return;
    }

    // Desactivar modo edición
    setEditandoConcepto(prev => ({
      ...prev,
      [key]: false
    }));

    // Conceptos de boleta interna: no recalcular PLAME
    if (
      tipo === 'ingresosInternos' ||
      tipo === 'descuentosInternos' ||
      tipo === 'aportesInternos'
    ) {
      console.log(`✅ Concepto interno guardado en ${tipo}[${index}]`);
      return;
    }

    // Ejecutar cálculo automático después de guardar
    await ejecutarCalculoAutomatico();
    console.log(`✅ Concepto guardado en ${tipo}[${index}]`);
  };

  const cancelarEdicionConcepto = (tipo, index) => {
    const key = `${tipo}_${index}`;
    setEditandoConcepto(prev => ({
      ...prev,
      [key]: false
    }));
    console.log(`❌ Edición cancelada en ${tipo}[${index}]`);
  };

  const actualizarConcepto = (tipo, id, campo, valor) => {
    setFormData(prev => ({
      ...prev,
      [tipo]: prev[tipo].map(item =>
        item.id === id ? { ...item, [campo]: valor } : item
      )
    }));
  };

  // Validar si los campos para "Generar" están completos
  const validarCamposGenerar = (fd = formData) => {
    // Validar tipo de contratación (obligatorio)
    if (!fd.tipoContratacion) {
      return false;
    }

    const esSoloInterna = planillaAlternativaActiva && fd.tipoPlanilla === 'solo_interna';
    const esDual = planillaAlternativaActiva && fd.tipoPlanilla === 'dual';

    // Si es Recibo por Honorarios, solo validar el monto
    if (fd.tipoContratacion === 'Recibo por Honorarios') {
      const monto = esSoloInterna ? fd.sueldoInterno : fd.sueldoBasico;
      if (!monto || parseFloat(monto) <= 0) {
        return false;
      }
      if (esDual && (!fd.sueldoInterno || parseFloat(fd.sueldoInterno) <= 0)) {
        return false;
      }
      return true;
    }

    // Solo interna: sueldo interno + régimen (sin ONP/AFP)
    if (esSoloInterna) {
      return (
        fd.sueldoInterno &&
        parseFloat(fd.sueldoInterno) > 0 &&
        !!fd.regimenLaboral
      );
    }

    // Dual / normal: aporte + sueldo PLAME + régimen (+ sueldo interno si dual)
    const esConsu = esRegimenConstruccionCivil(fd.regimenLaboral, regimenesLaborales);
    const sueldoPlameOk = esConsu || (fd.sueldoBasico && parseFloat(fd.sueldoBasico) > 0);
    const sueldoInternoOk =
      esConsu || !esDual || (fd.sueldoInterno && parseFloat(fd.sueldoInterno) > 0);

    const camposBasicos =
      fd.sistemaPensionario &&
      sueldoPlameOk &&
      sueldoInternoOk &&
      fd.regimenLaboral;

    if (esConsu && !parametrosConsu.length) {
      return false;
    }

    if (fd.sistemaPensionario === 'AFP') {
      return camposBasicos && fd.afp && fd.tipoAfp;
    }

    return camposBasicos;
  };

  useEffect(() => {
    if (!pendienteRecalcConsuEdicionRef.current) return;
    if (pendienteRecalcConsuEdicionRef.current !== empleado?.id) return;
    if (!modoEdicion) return;
    if (!parametrosConsu.length) return;
    if (!validarCamposGenerar()) return;

    pendienteRecalcConsuEdicionRef.current = null;

    (async () => {
      await recalcularRemuneracionConsu('edicion_empleado_carga');
      consuDebounceHabilitadoRef.current = true;
    })();
  }, [
    empleado?.id,
    modoEdicion,
    parametrosConsu.length,
    formData.regimenLaboral,
    formData.sistemaPensionario,
    formData.afp,
    formData.tipoAfp,
    formData.tipoContratacion,
    formData.tipoPlanilla,
    regimenesLaborales.length,
  ]);

  useEffect(() => {
    if (!consuDebounceHabilitadoRef.current) return;
    if (!esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)) return;
    if (!validarCamposGenerar()) return;

    const timer = setTimeout(() => {
      recalcularRemuneracionConsu('edicion_cambio_consu');
    }, 450);

    return () => clearTimeout(timer);
  }, [
    formData.regimenLaboral,
    formData.sistemaPensionario,
    formData.afp,
    formData.tipoAfp,
    fichaConsu.categoria,
    fichaConsu.modalidad_beneficios,
    fichaConsu.escolaridad_pago_mensual,
    fichaConsu.afiliacion_salud,
    parametrosConsu.length,
    regimenesLaborales.length,
  ]);

  const validateForm = () => {
    const newErrors = {};

    // Validaciones básicas
    if (!formData.nombreCompleto.trim()) {
      newErrors.nombreCompleto = 'Ingrese el nombre completo del empleado';
    }
    
    if (!formData.numeroDocumento.trim()) {
      newErrors.numeroDocumento = 'Ingrese el número de documento';
    } else if (formData.tipoDocumento === 'DNI' && formData.numeroDocumento.length !== 8) {
      newErrors.numeroDocumento = 'El DNI debe tener exactamente 8 dígitos';
    } else if (formData.tipoDocumento === 'DNI' && !/^\d+$/.test(formData.numeroDocumento)) {
      newErrors.numeroDocumento = 'El DNI solo debe contener números';
    }
    
    if (!formData.fechaNacimiento) {
      newErrors.fechaNacimiento = 'Seleccione la fecha de nacimiento';
    }
    
    // Validaciones de información laboral (todos obligatorios)
    if (!formData.cargo) newErrors.cargo = 'Especifique el cargo del empleado';
    if (!formData.categoria) newErrors.categoria = 'Seleccione la categoría laboral';
    if (!formData.proyecto) newErrors.proyecto = 'Asigne un proyecto al empleado';
    if (!formData.areaTrabajo) newErrors.areaTrabajo = 'Seleccione el área de trabajo';
    if (!formData.tipoContratacion) newErrors.tipoContratacion = 'Seleccione el tipo de contratación';
    else if (!esTipoContratacionEmpleadoValido(formData.tipoContratacion, planillaAlternativaActiva)) {
      newErrors.tipoContratacion = planillaAlternativaActiva
        ? 'El tipo de contratación debe ser Planilla, Recibo por Honorarios o Interno'
        : 'El tipo de contratación debe ser Planilla o Recibo por Honorarios';
    }
    
    // Solo validar fecha de ingreso y estado en modo creación
    if (!modoEdicion) {
      if (planillaAlternativaActiva) {
        if (!formData.tipoPlanilla) {
          newErrors.tipoPlanilla = 'Seleccione el tipo de planilla';
        }
        if (formData.tipoPlanilla === 'dual' && !formData.fechaIngreso) {
          newErrors.fechaIngreso = 'Seleccione la fecha de ingreso real (PLAME)';
        }
        if (!formData.fechaIngresoInterna) {
          newErrors.fechaIngresoInterna = 'Seleccione la fecha de ingreso interna (control)';
        }
      } else if (!formData.fechaIngreso) {
        newErrors.fechaIngreso = 'Seleccione la fecha de ingreso';
      }
      if (!formData.estado) newErrors.estado = 'Seleccione el estado del empleado';
    }

    if (planillaAlternativaActiva) {
      if (!formData.tipoPlanilla) {
        newErrors.tipoPlanilla = 'Seleccione el tipo de planilla';
      }
      if (!modoEdicion) {
        if (!formData.fechaIngresoInterna) {
          newErrors.fechaIngresoInterna = 'Seleccione la fecha de ingreso interna (control)';
        }
        if (formData.tipoPlanilla === 'dual' && !formData.fechaIngreso) {
          newErrors.fechaIngreso = 'Seleccione la fecha de ingreso real (PLAME)';
        }
      }
      const esConsu = esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales);
      if (!esConsu && (!formData.sueldoInterno || parseFloat(formData.sueldoInterno) <= 0)) {
        newErrors.sueldoInterno = 'Ingrese el sueldo interno (control)';
      }
      if (!esConsu && formData.tipoPlanilla === 'dual' && (!formData.sueldoBasico || parseFloat(formData.sueldoBasico) <= 0)) {
        newErrors.sueldoBasico = 'Ingrese el sueldo declarado (PLAME)';
      }
    }
    
    // Validar que tenga al menos un concepto de ingreso con monto
    const ingresosConMonto = formData.ingresos.filter(ingreso => ingreso.monto && parseFloat(ingreso.monto) > 0);
    if (
      !esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)
      && ingresosConMonto.length === 0
      && formData.ingresos.length > 0
    ) {
      newErrors.ingresos = 'Al menos un ingreso debe tener un monto válido mayor a 0';
    }

    // Validación de email
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Ingrese un email válido (ejemplo: usuario@dominio.com)';
    }

    // Validación de AFP si está seleccionada
    if (formData.sistemaPensionario === 'AFP') {
      if (!formData.afp) newErrors.afp = 'Seleccione una AFP del sistema privado de pensiones';
    }

    // Validación específica para número de hijos
    if (formData.numeroHijos < 0) {
      newErrors.numeroHijos = 'El número de hijos no puede ser negativo';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const persistirFichaConsu = async (empleadoId) => {
    if (!empleadoId || !selectedCompany?.id) return;
    if (!esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)) return;
    await construccionCivilService.guardarFicha(selectedCompany.id, empleadoId, {
      categoria: fichaConsu.categoria,
      modalidad_beneficios: fichaConsu.modalidad_beneficios,
      escolaridad_pago_mensual: !!fichaConsu.escolaridad_pago_mensual,
      afiliacion_salud: fichaConsu.afiliacion_salud,
      motivo: 'Asignación CONSU',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Limpiar mensajes anteriores
    setMensajeExito('');
    setMensajeError('');
    
    // Validar formulario
    if (!validateForm()) {
      const erroresEncontrados = Object.keys(errors).length;
      if (modoEdicion) {
        setMensajeError(`Por favor, corrija los ${erroresEncontrados} error(es) marcados en rojo antes de actualizar el empleado`);
      } else {
        setMensajeError(`Por favor, complete todos los campos obligatorios (${erroresEncontrados} pendientes)`);
      }
      return;
    }

    // Validar que hay una empresa seleccionada
    if (!selectedCompany?.id) {
      if (modoEdicion) {
        setMensajeError('Error: No se puede actualizar el empleado sin empresa seleccionada');
      } else {
        setMensajeError('Debe seleccionar una empresa antes de crear el empleado');
      }
      return;
    }

    // Si estamos en modo edición, usar el callback onSubmit del EditarEmpleado
    if (modoEdicion && onSubmit) {
      try {
        let conceptosDesdeConsu = null;
        if (
          esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)
          && validarCamposGenerar()
        ) {
          const pipe = await recalcularRemuneracionConsu('edicion_empleado_guardar');
          const listas = listasConceptosDesdePipeline(pipe, formData);
          if (listas) {
            conceptosDesdeConsu = prepararConceptosParaEnvio(listas);
          }
        }

        const dataParaEdicion = { ...formData };
        if (!planillaAlternativaActiva) {
          delete dataParaEdicion.tipoPlanilla;
          delete dataParaEdicion.fechaIngresoInterna;
          delete dataParaEdicion.sueldoInterno;
        } else if (!dataParaEdicion.tipoPlanilla) {
          dataParaEdicion.tipoPlanilla = 'dual';
        }
        // En edición, fechaIngreso sincroniza el periodo PLAME activo del historial
        if (planillaAlternativaActiva && dataParaEdicion.fechaIngreso) {
          // se envía como fecha_ingreso en el mapper
        } else if (!planillaAlternativaActiva) {
          delete dataParaEdicion.fechaIngreso;
        }
        // Conceptos ya resueltos por código PLAME (evita confusión id UI ↔ plame id)
        dataParaEdicion.conceptos =
          conceptosDesdeConsu ?? prepararConceptosParaEnvio();
        await onSubmit(dataParaEdicion);
        await persistirFichaConsu(empleado?.id);
      } catch (error) {
        setMensajeError(error.message || 'Error al actualizar el empleado');
      }
      return;
    }

    try {
      setGuardandoEmpleado(true);
      console.log('💾 Iniciando guardado de empleado...');

      let conceptosDesdeConsu = null;
      if (
        esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)
        && validarCamposGenerar()
      ) {
        const pipe = await recalcularRemuneracionConsu('creacion_empleado_guardar');
        const listas = listasConceptosDesdePipeline(pipe, formData);
        if (listas) {
          conceptosDesdeConsu = prepararConceptosParaEnvio(listas);
        }
      }

      // Preparar datos del empleado para enviar al backend
      const empleadoData = {
        // Información de la empresa
        empresa_id: selectedCompany.id,
        
        // Información Personal
        nombre_completo: formData.nombreCompleto.trim(),
        tipo_documento: formData.tipoDocumento,
        numero_documento: formData.numeroDocumento.trim(),
                 fecha_nacimiento: formData.fechaNacimiento || null,
         sexo: formData.sexo || null,
         estado_civil: mapearEstadoCivilParaBD(formData.estadoCivil) || null,
         numero_hijos: parseInt(formData.numeroHijos) || 0,
        telefono: formData.telefono?.trim() || null,
        email: formData.email?.trim() || null,
        direccion: formData.direccion?.trim() || null,
        distrito: formData.distrito?.trim() || null,
        provincia: formData.provincia?.trim() || null,
        departamento: formData.departamento?.trim() || null,
        
        // Información Laboral
        cargo: formData.cargo.trim(),
        categoria: formData.categoria.trim(),
        proyecto: formData.proyecto.trim(),
        areas_de_trabajo: formData.areaTrabajo.trim(),
        tipo_contratacion: formData.tipoContratacion,
        estado: formData.estado,
        regimen_laboral_id: obtenerIdRegimenLaboral(formData.regimenLaboral),
        fecha_computo_rh_id:
          formData.tipoContratacion === 'Recibo por Honorarios' && formData.computoRhId
            ? parseInt(formData.computoRhId, 10)
            : null,
        
        // Información Salarial
        sueldo_basico:
          planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna'
            ? (parseFloat(formData.sueldoInterno) || 0)
            : (parseFloat(formData.sueldoBasico) || 0),
        forma_pago:
          esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)
            ? 'mensual'
            : (formData.formaPago === 'jornal' ? 'jornal' : 'mensual'),
        sueldo_interno: planillaAlternativaActiva
          ? (parseFloat(formData.sueldoInterno) || null)
          : null,
        tipo_planilla: planillaAlternativaActiva ? (formData.tipoPlanilla || 'dual') : null,
        fecha_ingreso_interna: planillaAlternativaActiva
          ? (formData.fechaIngresoInterna || null)
          : null,
        
        // Sistema Pensionario
        sistema_pensionario: formData.sistemaPensionario,
        afp_id: formData.sistemaPensionario === 'AFP' ? obtenerIdAfp(formData.afp) : null,
        cuspp: formData.sistemaPensionario === 'AFP' ? (formData.cuspp?.trim() || null) : null,
        tipo_afp: formData.sistemaPensionario === 'AFP' ? (formData.tipoAfp || null) : 'Flujo',
        
        // Horarios
        hora_entrada: formData.horaEntrada,
        hora_salida: formData.horaSalida,
        
        // Información Adicional
        cuenta_bancaria: formData.cuentaBancaria?.trim() || null,
        banco: formData.banco?.trim() || null,
        cci: formData.cci?.trim() || null,
        cuenta_cts: formData.cuentaCts?.trim() || null,
        banco_cts: formData.bancoCts?.trim() || null,
        contacto_emergencia: formData.contactoEmergencia?.trim() || null,
        telefono_emergencia: formData.telefonoEmergencia?.trim() || null,
        observaciones: formData.observaciones?.trim() || null,
        
        // Configuraciones Adicionales
        asignacion_familiar: Boolean(formData.asignacionFamiliar),
        tiene_bono: Boolean(formData.tieneBono),
        monto_bono: formData.tieneBono ? (parseFloat(formData.montoBono) || 0) : 0,
        monto_viatico_standard: viaticosStandardActivo
          ? (parseFloat(formData.montoViaticoStandard) || 0)
          : 0,
        es_boleta_liquidada: Boolean(formData.esBoletaLiquidada),
        
        // Historial Laboral (se crea automáticamente)
        // Real/PLAME: dual usa fechaIngreso; solo_interna usa la fecha interna
        fecha_ingreso:
          planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna'
            ? formData.fechaIngresoInterna
            : formData.fechaIngreso,
        fecha_cese: formData.fechaCese || null,
        motivo_cese: formData.motivoCese?.trim() || null,
        
        // Conceptos (ingresos, descuentos, aportes)
        conceptos: conceptosDesdeConsu ?? prepararConceptosParaEnvio()
      };

      console.log('📋 Datos del empleado preparados:', empleadoData);

      // Enviar datos al backend
      const response = await empleadoService.createEmpleado(empleadoData);
      await persistirFichaConsu(response?.data?.id || response?.data?.empleado?.id);
      
      console.log('✅ Empleado creado exitosamente:', response);
      
      // Mostrar mensaje de éxito
      setMensajeExito(`✅ Empleado "${formData.nombreCompleto}" creado exitosamente`);
      
      // Esperar un momento para que se vea el mensaje de éxito, luego ejecutar callback
      setTimeout(() => {
        // Llamar al callback onSubmit si existe (para cerrar modal, etc.)
        if (onSubmit) {
          onSubmit(response.data);
        }
        
        // Si no hay callback onSubmit, limpiar el formulario después de mostrar el mensaje
        if (!onSubmit) {
          setTimeout(() => {
            limpiarFormulario();
            setMensajeExito('');
          }, 1500);
        }
      }, 1500);

    } catch (error) {
      console.error('❌ Error al guardar empleado:', error);
      setMensajeError(error.message || 'Error al guardar el empleado');
    } finally {
      setGuardandoEmpleado(false);
    }
  };

  // Función auxiliar para obtener ID del régimen laboral
  const obtenerIdRegimenLaboral = (nombreRegimen) => {
    if (!nombreRegimen || !regimenesLaborales.length) return null;
    const regimen = regimenesLaborales.find(r => r.nombre === nombreRegimen);
    return regimen?.id || null;
  };

  // Función auxiliar para obtener ID de AFP
  const obtenerIdAfp = (nombreAfp) => {
    console.log('🔍 DEBUG obtenerIdAfp:');
    console.log('  - Sistema pensionario:', formData.sistemaPensionario);
    console.log('  - Nombre AFP recibido:', nombreAfp);
    console.log('  - AFPs disponibles:', afpsData.length);
    console.log('  - Datos AFPs:', afpsData);
    
    // Si el sistema pensionario no es AFP, siempre retornar null
    if (formData.sistemaPensionario !== 'AFP') {
      console.log('  ❌ Sistema pensionario no es AFP, retornando null');
      return null;
    }
    
    // Si no hay nombre de AFP o no hay datos de AFPs, retornar null
    if (!nombreAfp || !afpsData.length) {
      console.log('  ❌ No hay nombre de AFP o no hay datos de AFPs disponibles');
      console.log('    - nombreAfp:', nombreAfp);
      console.log('    - afpsData.length:', afpsData.length);
      return null;
    }
    
    // Buscar la AFP por nombre
    const afp = afpsData.find(a => a.nombre === nombreAfp);
    console.log('  - AFP encontrada:', afp);
    
    if (afp) {
      console.log('  ✅ AFP ID encontrado:', afp.id);
      return afp.id;
    } else {
      console.log('  ❌ No se encontró AFP con nombre:', nombreAfp);
      console.log('  - Nombres disponibles:', afpsData.map(a => a.nombre));
      return null;
    }
  };

  // Función auxiliar para preparar conceptos para envío
  const prepararConceptosParaEnvio = (listasForm = null) => {
    const fuente = listasForm || formData;
    const conceptos = [];
    
    // Preferir plame_configuracion_id; luego código PLAME. Nunca usar el id de lista UI.
    const resolverIdPlame = (item) => {
      const desdeCampo = Number(item.plame_configuracion_id);
      if (Number.isInteger(desdeCampo) && desdeCampo > 0) return desdeCampo;

      const porCodigo = (codigosPlame || []).find(
        (c) => String(c.codigo) === String(item.codigoPlame)
      );
      if (porCodigo?.id) return Number(porCodigo.id);

      return null;
    };

    const agregar = (lista, tipoConcepto, tipoBoleta) => {
      (lista || []).forEach((item) => {
        const plameId = resolverIdPlame(item);
        if (!plameId) return;
      conceptos.push({
          plame_configuracion_id: plameId,
          tipo_concepto: tipoConcepto,
          tipo_boleta: tipoBoleta,
          monto: parseFloat(item.monto) || 0
      });
    });
    };

    // Boleta oficial (en solo_interna estos son los únicos conceptos del empleado)
    agregar(fuente.ingresos, 'ingreso', 'plame');
    agregar(fuente.descuentos, 'descuento', 'plame');
    agregar(fuente.aportes, 'aporte', 'plame');

    // Boleta interna de control (modo dual)
    agregar(fuente.ingresosInternos, 'ingreso', 'interna');
    agregar(fuente.descuentosInternos, 'descuento', 'interna');
    agregar(fuente.aportesInternos, 'aporte', 'interna');
    
    return conceptos;
  };

  // Función auxiliar para mapear estado civil al formato de la BD
  const mapearEstadoCivilParaBD = (estadoCivil) => {
    // El frontend puede mostrar valores más descriptivos, pero la BD usa valores simples
    const mapeo = {
      'Soltero(a)': 'Soltero',
      'Casado(a)': 'Casado',
      'Divorciado(a)': 'Divorciado',
      'Viudo(a)': 'Viudo',
      'Conviviente': 'Conviviente',
      // También mapear los valores simples por si vienen así
      'Soltero': 'Soltero',
      'Casado': 'Casado',
      'Divorciado': 'Divorciado',
      'Viudo': 'Viudo'
    };
    return mapeo[estadoCivil] || estadoCivil;
  };

  // Función auxiliar para limpiar el formulario
  const limpiarFormulario = () => {
    setFormData({
      // Información Personal
      nombreCompleto: '',
      tipoDocumento: 'DNI',
      numeroDocumento: '',
      fechaNacimiento: '',
      sexo: '',
      estadoCivil: '',
      numeroHijos: 0,
      telefono: '',
      email: '',
      direccion: '',
      distrito: '',
      provincia: '',
      departamento: '',
      
      // Información Laboral
      cargo: '',
      categoria: '',
      proyecto: '',
      areaTrabajo: '',
      tipoContratacion: '',
      fechaIngreso: '',
      fechaIngresoInterna: '',
      fechaCese: '',
      motivoCese: '',
      estado: 'Activo',
      tipoPlanilla: 'dual',
      regimenLaboral: '',
      computoRhId: '',
      
      // Información Salarial
      sueldoBasico: '',
      formaPago: 'mensual',
      sueldoInterno: '',
      asignacionFamiliar: false,
      tieneBono: false,
      montoBono: '',
      montoViaticoStandard: '',
      esBoletaLiquidada: false,
      
      // Conceptos dinámicos - INICIAR VACÍO
      ingresos: [],
      descuentos: [],
      aportes: [],
      ingresosInternos: [],
      descuentosInternos: [],
      aportesInternos: [],
      
      // Aportes adicionales
      tipoAfp: 'Flujo',
      
      // Sistema Pensionario
      sistemaPensionario: 'ONP',
      afp: '',
      cuspp: '',
      fechaAfiliacion: '',
      comisionAfp: '',
      
      // Horarios
      horarioTrabajo: 'completo',
      horaEntrada: '08:00',
      horaSalida: '17:00',
      horasSemanales: 48,
      diasTrabajo: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'],
      
      // Información Adicional
      cuentaBancaria: '',
      banco: '',
      cci: '',
      cuentaCts: '',
      bancoCts: '',
      contactoEmergencia: '',
      telefonoEmergencia: '',
      observaciones: ''
    });
    
    // Limpiar errores
    setErrors({});
    
    // Volver a la primera pestaña
    setActiveTab('personal');
  };

  // Función para manejar el botón Generar
  const handleGenerar = async () => {
    console.log('🔥 Función Generar ejecutada');
    try {
      // Dual + Interno es inconsistente: PLAME no calculaba desc/aportes.
      let snapshot = formData;
      if (
        planillaAlternativaActiva &&
        formData.tipoPlanilla === 'dual' &&
        formData.tipoContratacion === 'Interno'
      ) {
        snapshot = { ...formData, tipoContratacion: 'Planilla' };
        setFormData(snapshot);
        console.log('ℹ️ Dual + Interno → se normaliza contratación a Planilla');
      }

      const datosCompletos = await prepararDatosParaServicio(null, snapshot);
      console.log('🚀 Pipeline remuneración (PLAME → interna si aplica)...', {
        planillaAlternativaActiva,
        tipoPlanilla: snapshot.tipoPlanilla,
        tipoContratacion: snapshot.tipoContratacion,
        sueldoBasico: datosCompletos.datosSalariales?.sueldoBasico,
        sueldoInterno: datosCompletos.datosSalariales?.sueldoInterno,
      });
      await ejecutarPipelineCalculos(datosCompletos, 'formulario_empleados_boton_generar', {
        tipoPlanilla: snapshot.tipoPlanilla,
      });
      console.log('✅ Generar completado');
    } catch (error) {
      console.error('❌ Error en Generar:', error);
      alert(`Error al generar: ${error.message || error}`);
    }
  };

  // Configuraciones
  const baseTabs = [
    { id: 'personal', label: 'Personal', icon: '👤', color: 'teal' },
    { id: 'laboral', label: 'Laboral', icon: '💼', color: 'green' },
    { id: 'remuneracion', label: 'Remuneración', icon: '💰', color: 'emerald' },
    { id: 'horarios', label: 'Horarios', icon: '⏰', color: 'cyan' },
    { id: 'adicional', label: 'Adicional', icon: '📋', color: 'teal' }
  ];

  // Agregar pestaña de historial laboral solo en modo edición
  // y expediente laboral cuando la empresa lo tiene habilitado
  let tabs = modoEdicion
    ? [
        ...baseTabs.slice(0, 2), // personal y laboral
        { id: 'historial', label: 'Historial Laboral', icon: '📋', color: 'indigo' },
        ...baseTabs.slice(2) // remuneración, horarios, adicional
      ]
    : [...baseTabs];

  if (expedienteLaboralActivo) {
    const insertAt = tabs.findIndex((tab) => tab.id === 'remuneracion');
    const expedienteTab = { id: 'expediente', label: 'Expediente', icon: '🗂️', color: 'slate' };
    if (insertAt >= 0) {
      tabs = [...tabs.slice(0, insertAt), expedienteTab, ...tabs.slice(insertAt)];
    } else {
      tabs = [...tabs, expedienteTab];
    }
  }

  if (ssomaActivo) {
    const insertAt = tabs.findIndex((tab) => tab.id === 'remuneracion');
    const ssomaTab = { id: 'ssoma', label: 'SSOMA', icon: '🛡️', color: 'teal' };
    if (insertAt >= 0) {
      tabs = [...tabs.slice(0, insertAt), ssomaTab, ...tabs.slice(insertAt)];
    } else {
      tabs = [...tabs, ssomaTab];
    }
  }

  const tiposDocumento = ['DNI', 'Carnet de Extranjería', 'Pasaporte'];
  const sexos = ['Masculino', 'Femenino'];
  const estadosCiviles = ['Soltero', 'Casado', 'Divorciado', 'Viudo', 'Conviviente'];
  const estados = ['Activo', 'Inactivo', 'Suspendido'];
  const horariosTrabajo = [
    { value: 'completo', label: 'Tiempo Completo (8 horas)' },
    { value: 'medio', label: 'Medio Tiempo (4 horas)' },
    { value: 'personalizado', label: 'Horario Personalizado' }
  ];
  const diasSemana = [
    { value: 'lunes', label: 'Lunes' },
    { value: 'martes', label: 'Martes' },
    { value: 'miercoles', label: 'Miércoles' },
    { value: 'jueves', label: 'Jueves' },
    { value: 'viernes', label: 'Viernes' },
    { value: 'sabado', label: 'Sábado' },
    { value: 'domingo', label: 'Domingo' }
  ];

  const afps = ['AFP Integra', 'AFP Prima', 'AFP Profuturo', 'AFP Habitat'];
  const bancos = [
    // Bancos principales
    'BCP', 'BBVA', 'Interbank', 'Scotiabank', 'BanBif', 'Banco de la Nación',
    'Banco Pichincha', 'Mibanco', 'Banco Ripley', 'Banco Azteca',
    'Banco GNB', 'Banco Santander', 'Citibank', 'Banco Falabella',
    
    // Cajas Municipales
    'Caja Sullana', 'Caja Piura', 'Caja Maynas', 'Caja Cusco',
    'Caja Trujillo', 'Caja Huancayo', 'Caja Tacna', 'Caja Arequipa',
    'Caja Ica', 'Caja Lima', 'Caja Paita', 'Caja del Santa',
    
    // Financieras
    'Financiera Compartamos', 'Financiera Confianza', 'Financiera Crediscotia',
    'Financiera Efectiva', 'Financiera Qapaq', 'Financiera TFC',
    'Financiera Proempresa', 'Financiera Mitsui'
  ];

  // Función para contar APIs cargadas
  const contarApisCargadas = () => {
    let cargadas = 0;
    if (!loadingAtributos) cargadas++;
    if (!loadingRegimenes) cargadas++;
    if (!loadingFormulas) cargadas++;
    if (!loadingAfpsData) cargadas++;
    if (!loadingInformacionGeneral) cargadas++;
    if (!loadingTramosRenta) cargadas++;
    if (!loadingConfigRentaQuinta) cargadas++;
    return cargadas;
  };

  // Mostrar pantalla de progreso mientras cargan las APIs principales
  if (loadingAtributos || loadingRegimenes || cargandoProgreso.progreso < cargandoProgreso.total) {
    const porcentajeProgreso = Math.round((cargandoProgreso.progreso / cargandoProgreso.total) * 100);
    const tiempoTranscurrido = cargandoProgreso.tiempoInicio ? 
      Math.round((Date.now() - cargandoProgreso.tiempoInicio) / 1000) : 0;

    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="max-w-md w-full mx-4">
          {/* Card principal */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            {/* Header */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                {empleado ? 'Cargando Empleado' : 'Preparando Formulario'}
              </h2>
              <p className="text-gray-600">Iniciando configuración del sistema...</p>
            </div>

            {/* Barra de progreso */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700">
                  {cargandoProgreso.progreso}/{cargandoProgreso.total} APIs cargadas
                </span>
                <span className="text-sm font-medium text-teal-600">{porcentajeProgreso}%</span>
              </div>
              
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                <div 
                  className="bg-gradient-to-r from-teal-500 to-teal-600 h-3 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${porcentajeProgreso}%` }}
                ></div>
              </div>
            </div>

            {/* API actual */}
            {cargandoProgreso.apiActual && (
              <div className="flex items-center justify-center space-x-2 mb-4">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-teal-500"></div>
                <span className="text-sm text-gray-600">{cargandoProgreso.apiActual}</span>
              </div>
            )}

            {/* APIs completadas - mostrar discretamente */}
            {cargandoProgreso.apisCompletadas.length > 0 && (
              <div className="border-t pt-4">
                <p className="text-xs text-gray-500 mb-2">APIs cargadas:</p>
                <div className="flex flex-wrap gap-1">
                  {cargandoProgreso.apisCompletadas.map((api, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-800"
                    >
                      ✓ {api.replace(/[📊🏛️🧮🏦ℹ️💰💸]/g, '')}
                    </span>
                  ))}
                </div>
                
                {/* Tiempo transcurrido */}
                {tiempoTranscurrido > 0 && (
                  <p className="text-xs text-gray-400 mt-2">
                    Tiempo transcurrido: {tiempoTranscurrido}s
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto bg-gray-50 min-h-screen">
      {/* Header con información del empleado - Estilo Teal */}
      <div className="bg-gradient-to-r from-teal-500 via-teal-600 to-cyan-600 rounded-t-xl shadow-lg">
        <div className="px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-6">
                              <div className="relative">
                <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center border-4 border-white border-opacity-30">
                  <span className="text-3xl font-bold text-white">
                    {empleado ? `${empleado.nombres?.charAt(0) || ''}${empleado.apellidos?.charAt(0) || ''}` : '👤'}
                  </span>
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-400 rounded-full border-2 border-white shadow-lg"></div>
              </div>
              <div className="text-white">
                <h1 className="text-3xl font-bold mb-1">
                  {empleado ? `${empleado.nombres || ''} ${empleado.apellidos || ''}` : 'Nuevo Empleado'}
                </h1>
                <p className="text-teal-100 text-lg">
                  {empleado ? empleado.cargo || 'Sin cargo asignado' : 'Completar información del empleado'}
                </p>
                {empleado && (
                  <div className="flex items-center space-x-4 mt-2 text-teal-100">
                    <span className="flex items-center space-x-1">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                      </svg>
                      <span>Ingreso: {empleado.fechaIngreso}</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <div className={`w-2 h-2 rounded-full ${empleado.estado === 'Activo' ? 'bg-green-400' : 'bg-red-400'}`}></div>
                      <span>{empleado.estado}</span>
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="text-right text-white">
              <div className="text-sm text-teal-100">Estado</div>
              <div className="flex items-center space-x-2">
                <div className={`w-3 h-3 rounded-full ${formData.estado === 'Activo' ? 'bg-green-400' : 'bg-red-400'}`}></div>
                <div className="text-xl font-semibold">{formData.estado || 'Activo'}</div>
              </div>
              
              {/* Indicador discreto de APIs cargadas - mejorado */}
              <div className="mt-3 flex justify-end">
                <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-white bg-opacity-20 text-teal-100">
                  <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {cargandoProgreso.progreso}/{cargandoProgreso.total} APIs
                  {cargandoProgreso.progreso === cargandoProgreso.total && (
                    <span className="ml-1">✅</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs - Estilo moderno */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-8">
          <nav className="flex space-x-0">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative px-6 py-4 text-sm font-medium transition-all duration-300 ${
                  activeTab === tab.id
                    ? `text-${tab.color}-600 bg-${tab.color}-50`
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <span className="text-lg">{tab.icon}</span>
                  <span>{tab.label}</span>
                </div>
                {activeTab === tab.id && (
                  <div className={`absolute bottom-0 left-0 right-0 h-1 bg-${tab.color}-600 rounded-t-sm`}></div>
                )}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="pb-8">
        {/* Contenido de las pestañas */}
        <div className="px-8 py-6">
          {/* Tab: Información Personal */}
          {activeTab === 'personal' && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-50 to-blue-100 px-6 py-4 border-b border-blue-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">👤</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-blue-900">Información Personal</h3>
                    <p className="text-blue-600 text-sm">Datos básicos del empleado</p>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {/* Tipo de Documento */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Tipo de Documento <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.tipoDocumento}
                      onChange={(e) => handleInputChange('tipoDocumento', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                    >
                      {tiposDocumento.map(tipo => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </select>
                  </div>

                  {/* Número de Documento */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Número de Documento <span className="text-red-500">*</span>
                      {formData.tipoDocumento === 'DNI' && (
                        <span className="text-xs text-gray-500 ml-2">
                          (Consulta automática disponible)
                        </span>
                      )}
                    </label>
                    <div className="relative">
                    <input
                      type="text"
                      value={formData.numeroDocumento}
                      onChange={(e) => handleInputChange('numeroDocumento', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.numeroDocumento 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-blue-500 bg-white'
                        } ${consultandoDNI ? 'pr-10' : ''}`}
                      placeholder="Número de documento"
                        maxLength={formData.tipoDocumento === 'DNI' ? 8 : undefined}
                      />
                      {consultandoDNI && (
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                          <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                        </div>
                      )}
                    </div>
                    {errors.numeroDocumento && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.numeroDocumento}</span>
                      </p>
                    )}
                  </div>

                  {/* Nombre Completo */}
                  <div className="space-y-2 md:col-span-2 lg:col-span-1">
                    <label className="block text-sm font-semibold text-gray-700">
                      Nombre Completo <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.nombreCompleto}
                      onChange={(e) => handleInputChange('nombreCompleto', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.nombreCompleto 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-blue-500 bg-white'
                      }`}
                      placeholder="Nombres y apellidos completos"
                    />
                    {errors.nombreCompleto && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.nombreCompleto}</span>
                      </p>
                    )}
                  </div>

                  {/* Fecha de Nacimiento */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Fecha de Nacimiento <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={formData.fechaNacimiento}
                      onChange={(e) => handleInputChange('fechaNacimiento', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.fechaNacimiento 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-blue-500 bg-white'
                      }`}
                    />
                    {errors.fechaNacimiento && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.fechaNacimiento}</span>
                      </p>
                    )}
                  </div>

                  {/* Sexo */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Sexo</label>
                    <select
                      value={formData.sexo}
                      onChange={(e) => handleInputChange('sexo', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                    >
                      <option value="">Seleccionar...</option>
                      {sexos.map(sexo => (
                        <option key={sexo} value={sexo}>{sexo}</option>
                      ))}
                    </select>
                  </div>

                  {/* Estado Civil */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Estado Civil</label>
                    <select
                      value={formData.estadoCivil}
                      onChange={(e) => handleInputChange('estadoCivil', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                    >
                      <option value="">Seleccionar...</option>
                      {estadosCiviles.map(estado => (
                        <option key={estado} value={estado}>{estado}</option>
                      ))}
                    </select>
                  </div>

                  {/* Número de Hijos */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Número de Hijos</label>
                    <select
                      value={formData.numeroHijos}
                      onChange={(e) => handleInputChange('numeroHijos', parseInt(e.target.value) || 0)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                    >
                      <option value={0}>Sin hijos</option>
                      <option value={1}>1 hijo</option>
                      <option value={2}>2 hijos</option>
                      <option value={3}>3 hijos</option>
                      <option value={4}>4 hijos</option>
                      <option value={5}>5 hijos</option>
                      <option value={6}>6 hijos</option>
                      <option value={7}>7 hijos</option>
                      <option value={8}>8 hijos</option>
                      <option value={9}>9 hijos</option>
                      <option value={10}>10 o más hijos</option>
                    </select>
                  </div>

                  {/* Teléfono */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Teléfono</label>
                    <input
                      type="tel"
                      value={formData.telefono}
                      onChange={(e) => handleInputChange('telefono', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                      placeholder="Número de teléfono"
                    />
                  </div>

                  {/* Email */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Email</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.email 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-blue-500 bg-white'
                      }`}
                      placeholder="correo@ejemplo.com"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.email}</span>
                      </p>
                    )}
                  </div>

                  {/* Dirección - Campo completo */}
                  <div className="md:col-span-2 lg:col-span-3 space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Dirección</label>
                    <input
                      type="text"
                      value={formData.direccion}
                      onChange={(e) => handleInputChange('direccion', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                      placeholder="Dirección completa"
                    />
                  </div>

                  {/* Distrito */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Distrito</label>
                    <input
                      type="text"
                      value={formData.distrito}
                      onChange={(e) => handleInputChange('distrito', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                      placeholder="Distrito"
                    />
                  </div>

                  {/* Provincia */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Provincia</label>
                    <input
                      type="text"
                      value={formData.provincia}
                      onChange={(e) => handleInputChange('provincia', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                      placeholder="Provincia"
                    />
                  </div>

                  {/* Departamento */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">Departamento</label>
                    <input
                      type="text"
                      value={formData.departamento}
                      onChange={(e) => handleInputChange('departamento', e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 bg-white"
                      placeholder="Departamento"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Tab: Información Laboral */}
          {activeTab === 'laboral' && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-green-50 to-green-100 px-6 py-4 border-b border-green-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">💼</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-green-900">Información Laboral</h3>
                    <p className="text-green-600 text-sm">Datos del puesto y contratación</p>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {/* Cargo */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Cargo <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.cargo}
                      onChange={(e) => handleInputChange('cargo', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.cargo 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-green-500 bg-white'
                      }`}
                    >
                      <option value="">Seleccionar cargo...</option>
                      {(atributosData.Cargos || []).map(cargo => (
                        <option key={cargo.id} value={cargo.nombre}>{cargo.nombre}</option>
                      ))}
                    </select>
                    {errors.cargo && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.cargo}</span>
                      </p>
                    )}
                  </div>

                  {/* Categoría */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Categoría <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.categoria}
                      onChange={(e) => handleInputChange('categoria', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.categoria 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-green-500 bg-white'
                      }`}
                    >
                      <option value="">Seleccionar categoría...</option>
                      {(atributosData.Categorías || []).map(categoria => (
                        <option key={categoria.id} value={categoria.nombre}>{categoria.nombre}</option>
                      ))}
                    </select>
                    {errors.categoria && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.categoria}</span>
                      </p>
                    )}
                  </div>

                  {/* Proyecto */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Proyecto <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.proyecto}
                      onChange={(e) => handleInputChange('proyecto', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.proyecto 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-green-500 bg-white'
                      }`}
                    >
                      <option value="">Seleccionar proyecto...</option>
                      {(atributosData.Proyectos || []).map(proyecto => (
                        <option key={proyecto.id} value={proyecto.nombre}>{proyecto.nombre}</option>
                      ))}
                    </select>
                    {errors.proyecto && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.proyecto}</span>
                      </p>
                    )}
                  </div>

                  {/* Área de Trabajo - Carga desde backend como atributo */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Área de Trabajo <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.areaTrabajo}
                      onChange={(e) => handleInputChange('areaTrabajo', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.areaTrabajo 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-green-500 bg-white'
                      }`}
                      disabled={loadingAtributos}
                    >
                                              <option value="">{loadingAtributos ? 'Cargando áreas de trabajo...' : 'Seleccionar área de trabajo...'}</option>
                                              {(() => {
                        console.log('🔍 Renderizando select - atributosData:', atributosData);
                        console.log('🔍 Keys disponibles:', Object.keys(atributosData));
                        
                        // Intentar diferentes variaciones del nombre
                        const possibleKeys = [
                          'Áreas',
                          'Areas de Trabajo', 
                          'Área de Trabajo', 
                          'areas_de_trabajo', 
                          'area_de_trabajo',
                          'AREAS DE TRABAJO',
                          'Area de Trabajo',
                        ];
                        
                        let areasData = [];
                        let foundKey = '';
                        
                        for (const key of possibleKeys) {
                          if (atributosData[key] && Array.isArray(atributosData[key])) {
                            areasData = atributosData[key];
                            foundKey = key;
                            break;
                          }
                        }
                        
                        console.log('🔍 Key encontrada para áreas:', foundKey);
                        console.log('🔍 Areas data:', areasData);
                        
                        if (areasData.length > 0) {
                          console.log('✅ Renderizando', areasData.length, 'áreas de trabajo');
                          return areasData.map(area => (
                            <option key={area.id || area.nombre} value={area.nombre}>{area.nombre}</option>
                          ));
                        } else {
                          console.warn('❌ No hay áreas de trabajo para renderizar');
                          return <option value="" disabled>No hay áreas de trabajo configuradas</option>;
                        }
                      })()}
                    </select>
                    {errors.areaTrabajo && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.areaTrabajo}</span>
                      </p>
                    )}
                  </div>

                  {/* Tipo de Contratación */}
                  <div className="space-y-2">
                    <label className="block text-sm font-semibold text-gray-700">
                      Tipo de Contratación <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={formData.tipoContratacion}
                      onChange={(e) => handleInputChange('tipoContratacion', e.target.value)}
                      className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                        errors.tipoContratacion 
                          ? 'border-red-300 focus:border-red-500 bg-red-50' 
                          : 'border-gray-200 focus:border-green-500 bg-white'
                      }`}
                    >
                      <option value="">Seleccionar tipo...</option>
                      {obtenerTiposContratacionEmpleado(planillaAlternativaActiva).map((tipo) => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </select>
                    {errors.tipoContratacion && (
                      <p className="text-red-500 text-xs flex items-center space-x-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <span>{errors.tipoContratacion}</span>
                      </p>
                    )}
                  </div>

                  {formData.tipoContratacion === 'Recibo por Honorarios' && (
                    <div className="space-y-2">
                      <label className="block text-sm font-semibold text-gray-700">
                        Cómputo RH (opcional)
                      </label>
                      <select
                        value={formData.computoRhId || ''}
                        onChange={(e) => handleInputChange('computoRhId', e.target.value)}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-500 bg-white"
                        disabled={loadingComputoRh}
                      >
                        <option value="">
                          {loadingComputoRh ? 'Cargando cómputos...' : 'Puede dejarse vacío'}
                        </option>
                        {opcionesComputoRh.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.titulo || `Cómputo #${item.id}`}
                          </option>
                        ))}
                      </select>
                      <p className="text-xs text-gray-500">
                        Aplica esta sección para personal en Recibo por Honorarios.
                      </p>
                    </div>
                  )}

                  {/* Planilla alternativa: sección a todo el ancho (3 columnas) */}
                  {planillaAlternativaActiva && (
                    <div className="col-span-1 md:col-span-2 lg:col-span-3">
                      <div className="rounded-xl border border-indigo-200 bg-white overflow-hidden">
                        <div className="bg-gradient-to-r from-indigo-50 to-violet-50 px-5 py-4 border-b border-indigo-100">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center shrink-0">
                              <span className="text-white text-sm font-bold">PA</span>
                            </div>
                            <div>
                              <h4 className="text-base font-semibold text-indigo-950">Planilla alternativa</h4>
                              <p className="text-xs text-indigo-700/80 mt-0.5">
                                {modoEdicion
                                  ? 'Real = PLAME · Interna = control. Las fechas se gestionan en Historial Laboral.'
                                  : 'Real = PLAME · Interna = control. Al crear, las fechas inician ambos historiales.'}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="p-5 space-y-5">
                          <div className="w-full">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Tipo de planilla <span className="text-red-500">*</span>
                            </label>
                            <select
                              value={formData.tipoPlanilla || 'dual'}
                              onChange={(e) => handleTipoPlanillaChange(e.target.value)}
                              className={`w-full px-4 py-3 border-2 rounded-lg text-sm focus:outline-none transition-colors ${
                                errors.tipoPlanilla
                                  ? 'border-red-300 focus:border-red-500 bg-red-50'
                                  : 'border-gray-200 focus:border-indigo-500 bg-white'
                              }`}
                            >
                              <option value="dual">Dual (PLAME + interna)</option>
                              <option value="solo_interna">Solo interna (control)</option>
                            </select>
                            {errors.tipoPlanilla && (
                              <p className="text-red-500 text-xs mt-1">{errors.tipoPlanilla}</p>
                            )}
                          </div>

                          {modoEdicion ? (
                            <div className={`grid gap-4 w-full ${formData.tipoPlanilla === 'solo_interna' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'}`}>
                              {formData.tipoPlanilla !== 'solo_interna' && (
                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 w-full">
                                  <div className="flex items-center gap-2 mb-2">
                                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-700 text-white text-xs font-bold">
                                      P
                                    </span>
                                    <div>
                                      <p className="text-sm font-semibold text-slate-900">Real · PLAME</p>
                                      <p className="text-xs text-slate-500">Declarada / oficial</p>
                                    </div>
                                  </div>
                                  <p className="text-xs text-slate-600 leading-relaxed">
                                    Fechas de ingreso y cese en la pestaña <strong>Historial Laboral PLAME</strong>.
                                  </p>
                                </div>
                              )}
                              <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 w-full">
                                <div className="flex items-center gap-2 mb-2">
                                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-amber-600 text-white text-xs font-bold">
                                    I
                                  </span>
                                  <div>
                                    <p className="text-sm font-semibold text-amber-950">Interna · Control</p>
                                    <p className="text-xs text-amber-800/80">Planilla de control</p>
                                  </div>
                                </div>
                                <p className="text-xs text-amber-900/80 leading-relaxed">
                                  Fechas de ingreso y cese en la pestaña <strong>Historial Laboral Interno</strong>.
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className={`grid gap-4 w-full ${formData.tipoPlanilla === 'solo_interna' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'}`}>
                              {formData.tipoPlanilla !== 'solo_interna' && (
                                <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 w-full">
                                  <div className="flex items-center gap-2 mb-3">
                                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-700 text-white text-xs font-bold">
                                      P
                                    </span>
                                    <div>
                                      <p className="text-sm font-semibold text-slate-900">Real · PLAME</p>
                                      <p className="text-xs text-slate-500">Declarada / oficial</p>
                                    </div>
                                  </div>
                                  <label className="block text-sm font-semibold text-slate-700 mb-1">
                                    Fecha de ingreso <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    type="date"
                                    value={formData.fechaIngreso}
                                    onChange={(e) => handleInputChange('fechaIngreso', e.target.value)}
                                    className={`w-full px-4 py-3 border-2 rounded-lg text-sm focus:outline-none bg-white ${
                                      errors.fechaIngreso
                                        ? 'border-red-300 focus:border-red-500'
                                        : 'border-slate-200 focus:border-slate-500'
                                    }`}
                                  />
                                  {errors.fechaIngreso && (
                                    <p className="text-red-500 text-xs mt-1">{errors.fechaIngreso}</p>
                                  )}
                                </div>
                              )}

                              <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 w-full">
                                <div className="flex items-center gap-2 mb-3">
                                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-amber-600 text-white text-xs font-bold">
                                    I
                                  </span>
                                  <div>
                                    <p className="text-sm font-semibold text-amber-950">Interna · Control</p>
                                    <p className="text-xs text-amber-800/80">Planilla de control</p>
                                  </div>
                                </div>
                                <label className="block text-sm font-semibold text-amber-950 mb-1">
                                  Fecha de ingreso <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="date"
                                  value={formData.fechaIngresoInterna}
                                  onChange={(e) => handleInputChange('fechaIngresoInterna', e.target.value)}
                                  className={`w-full px-4 py-3 border-2 rounded-lg text-sm focus:outline-none bg-white ${
                                    errors.fechaIngresoInterna
                                      ? 'border-red-300 focus:border-red-500'
                                      : 'border-amber-200 focus:border-amber-500'
                                  }`}
                                />
                                {errors.fechaIngresoInterna && (
                                  <p className="text-red-500 text-xs mt-1">{errors.fechaIngresoInterna}</p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Fecha de Ingreso - Solo en modo creación sin planilla alternativa */}
                  {!modoEdicion && !planillaAlternativaActiva && (
                    <div className="space-y-2">
                      <label className="block text-sm font-semibold text-gray-700">
                        Fecha de Ingreso <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        value={formData.fechaIngreso}
                        onChange={(e) => handleInputChange('fechaIngreso', e.target.value)}
                        className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                          errors.fechaIngreso 
                            ? 'border-red-300 focus:border-red-500 bg-red-50' 
                            : 'border-gray-200 focus:border-green-500 bg-white'
                        }`}
                      />
                      {errors.fechaIngreso && (
                        <p className="text-red-500 text-xs flex items-center space-x-1">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <span>{errors.fechaIngreso}</span>
                        </p>
                      )}
                    </div>
                  )}

                  {/* Estado - Solo en modo creación */}
                  {!modoEdicion && (
                    <div className="space-y-2">
                      <label className="block text-sm font-semibold text-gray-700">
                        Estado <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={formData.estado}
                        onChange={(e) => handleInputChange('estado', e.target.value)}
                        className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none transition-colors ${
                          errors.estado 
                            ? 'border-red-300 focus:border-red-500 bg-red-50' 
                            : 'border-gray-200 focus:border-green-500 bg-white'
                        }`}
                      >
                        {estados.map(estado => (
                          <option key={estado} value={estado}>{estado}</option>
                        ))}
                      </select>
                      {errors.estado && (
                        <p className="text-red-500 text-xs flex items-center space-x-1">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <span>{errors.estado}</span>
                        </p>
                      )}
                    </div>
                  )}

                  {/* Campos de cese si está inactivo */}
                  {formData.estado === 'Inactivo' && (
                    <>
                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Fecha de Cese</label>
                        <input
                          type="date"
                          value={formData.fechaCese}
                          onChange={(e) => handleInputChange('fechaCese', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-500 bg-white"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Motivo de Cese</label>
                        <select
                          value={formData.motivoCese}
                          onChange={(e) => handleInputChange('motivoCese', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-green-500 bg-white"
                        >
                          <option value="">Seleccionar motivo...</option>
                          {(atributosData['Motivos de Cese'] || []).map(motivo => (
                            <option key={motivo.id} value={motivo.nombre}>{motivo.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Tab: Historial Laboral - Solo en modo edición */}
          {activeTab === 'historial' && modoEdicion && (
            <div className="space-y-6">
              {mensajeHistorial && (
                <div
                  className={`rounded-lg px-4 py-3 text-sm ${
                    mensajeHistorial.tipo === 'success'
                      ? 'bg-green-50 text-green-800 border border-green-200'
                      : 'bg-red-50 text-red-800 border border-red-200'
                  }`}
                >
                  {mensajeHistorial.texto}
                </div>
              )}

              {/* Historial PLAME — oculto si el empleado es solo interna */}
              {!(planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna') && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-slate-50 to-slate-100 px-6 py-4 border-b border-slate-200">
                  <div className="flex items-center justify-between gap-3">
                <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center">
                        <span className="text-white text-sm font-bold">P</span>
                  </div>
                  <div>
                        <h3 className="text-xl font-semibold text-slate-900">
                          {planillaAlternativaActiva ? 'Historial Laboral PLAME' : 'Historial Laboral'}
                        </h3>
                        <p className="text-slate-600 text-sm">
                          {planillaAlternativaActiva
                            ? 'Vínculo real / declarado (oficial)'
                            : 'Registro de cambios y movimientos laborales'}
                        </p>
                  </div>
                </div>
                    <button
                      type="button"
                      onClick={() => abrirModalNuevoHistorial('plame')}
                      className="inline-flex items-center px-3 py-2 rounded-md text-sm font-medium text-white bg-slate-700 hover:bg-slate-800"
                    >
                      <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      Agregar
                    </button>
              </div>
                </div>
              <div className="p-6">
                  <p className="text-sm text-gray-600 mb-4">
                    Pulse <strong>Editar</strong> para modificar fechas y motivo de cese. Sin fecha de cese = <strong>Activo</strong>.
                  </p>
                  {historialLocal && historialLocal.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                      <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Fecha Ingreso</th>
                            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Fecha Cese</th>
                            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Motivo Cese</th>
                            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Estado</th>
                            <th className="px-6 py-3 border-b border-gray-200 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">Acción</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                          {historialLocal.map((registro, index) => (
                          <tr key={registro.id || index} className="hover:bg-gray-50 transition-colors">
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatearFechaHistorialDisplay(registro.fecha_ingreso)}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatearFechaHistorialDisplay(registro.fecha_cese)}</td>
                              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs">{registro.motivo_cese || '—'}</td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${!registro.fecha_cese ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                  {!registro.fecha_cese ? 'Activo' : 'Cesado'}
                                </span>
                            </td>
                              <td className="px-6 py-4 whitespace-nowrap text-right">
                                <button
                                  type="button"
                                  onClick={() => abrirModalEditarHistorial(registro, 'plame')}
                                  disabled={!registro.id || guardandoHistorialId === registro.id}
                                  className="px-3 py-1.5 bg-blue-100 text-blue-700 text-sm font-medium rounded-md hover:bg-blue-200 disabled:opacity-50"
                                >
                                  Editar
                                </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                    <div className="text-center py-10 text-gray-500 text-sm">Sin registros de historial PLAME.</div>
                  )}
                </div>
              </div>
              )}

              {/* Historial Interno */}
              {planillaAlternativaActiva && (
                <div className="bg-white rounded-xl shadow-sm border border-amber-200 overflow-hidden">
                  <div className="bg-gradient-to-r from-amber-50 to-amber-100 px-6 py-4 border-b border-amber-200">
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center">
                          <span className="text-white text-sm font-bold">I</span>
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-amber-950">
                            {formData.tipoPlanilla === 'solo_interna'
                              ? 'Historial Laboral'
                              : 'Historial Laboral Interno'}
                          </h3>
                          <p className="text-amber-800 text-sm">
                            {formData.tipoPlanilla === 'solo_interna'
                              ? 'Vínculo de control (solo planilla interna)'
                              : 'Vínculo de control (planilla interna)'}
                          </p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => abrirModalNuevoHistorial('interno')}
                        className="inline-flex items-center px-3 py-2 rounded-md text-sm font-medium text-white bg-amber-600 hover:bg-amber-700"
                      >
                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                        Agregar
                      </button>
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="text-sm text-gray-600 mb-4">
                      {formData.tipoPlanilla === 'solo_interna' ? (
                        <>Pulse <strong>Editar</strong> para modificar fechas y motivo de cese. Sin fecha de cese = <strong>Activo</strong>.</>
                      ) : (
                        <>Lista separada del historial PLAME. Aquí se mueven las fechas de ingreso/cese internas.</>
                      )}
                    </p>
                    {historialInternoLocal && historialInternoLocal.length > 0 ? (
                      <div className="overflow-x-auto">
                        <table className="min-w-full bg-white border border-amber-100 rounded-lg">
                          <thead className="bg-amber-50">
                            <tr>
                              <th className="px-6 py-3 border-b border-amber-100 text-left text-xs font-semibold text-amber-900 uppercase tracking-wider">Fecha Ingreso</th>
                              <th className="px-6 py-3 border-b border-amber-100 text-left text-xs font-semibold text-amber-900 uppercase tracking-wider">Fecha Cese</th>
                              <th className="px-6 py-3 border-b border-amber-100 text-left text-xs font-semibold text-amber-900 uppercase tracking-wider">Motivo Cese</th>
                              <th className="px-6 py-3 border-b border-amber-100 text-left text-xs font-semibold text-amber-900 uppercase tracking-wider">Estado</th>
                              <th className="px-6 py-3 border-b border-amber-100 text-right text-xs font-semibold text-amber-900 uppercase tracking-wider">Acción</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-amber-100">
                            {historialInternoLocal.map((registro, index) => (
                              <tr key={registro.id || index} className="hover:bg-amber-50/50 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatearFechaHistorialDisplay(registro.fecha_ingreso)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatearFechaHistorialDisplay(registro.fecha_cese)}</td>
                                <td className="px-6 py-4 text-sm text-gray-900 max-w-xs">{registro.motivo_cese || '—'}</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${!registro.fecha_cese ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                    {!registro.fecha_cese ? 'Activo' : 'Cesado'}
                                  </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right">
                                  <button
                                    type="button"
                                    onClick={() => abrirModalEditarHistorial(registro, 'interno')}
                                    disabled={!registro.id || guardandoHistorialId === registro.id}
                                    className="px-3 py-1.5 bg-amber-100 text-amber-800 text-sm font-medium rounded-md hover:bg-amber-200 disabled:opacity-50"
                                  >
                                    Editar
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                  </div>
                    ) : (
                      <div className="text-center py-10 text-amber-800/70 text-sm">Sin registros de historial interno.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {showEditarHistorialModal && (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60]">
              <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-2xl shadow-lg rounded-md bg-white">
                <div className="mt-3">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">
                    {editandoHistorial?.id
                      ? (historialModalTipo === 'interno'
                          ? 'Editar historial laboral interno'
                          : 'Editar historial laboral PLAME')
                      : (historialModalTipo === 'interno'
                          ? 'Agregar historial laboral interno'
                          : 'Agregar historial laboral PLAME')}
                  </h3>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha Ingreso *</label>
                      <input
                        type="date"
                        value={fechaIngresoEdit}
                        onChange={(e) => setFechaIngresoEdit(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha Cese (opcional)</label>
                      <input
                        type="date"
                        value={fechaCeseEdit}
                        onChange={(e) => {
                          const val = e.target.value;
                          setFechaCeseEdit(val);
                          if (!val) setMotivoCeseEdit('');
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Si deja la fecha de cese en blanco, el trabajador quedará activo en ese vínculo.
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Motivo de cese {fechaCeseEdit ? '*' : ''}
                      </label>
                      <select
                        value={motivoCeseEdit}
                        onChange={(e) => setMotivoCeseEdit(e.target.value)}
                        disabled={!fechaCeseEdit}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100 disabled:text-gray-400"
                      >
                        <option value="">Seleccionar motivo</option>
                        {MOTIVOS_CESE.map((motivo) => (
                          <option key={motivo} value={motivo}>
                            {motivo}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 mt-6">
                    <button
                      type="button"
                      onClick={cerrarModalEditarHistorial}
                      disabled={!!guardandoHistorialId}
                      className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-300 disabled:opacity-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      onClick={guardarEdicionHistorialModal}
                      disabled={
                        !!guardandoHistorialId ||
                        !fechaIngresoEdit ||
                        (fechaCeseEdit && !motivoCeseEdit)
                      }
                      className="px-4 py-2 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700 disabled:opacity-50 flex items-center"
                    >
                      {guardandoHistorialId
                        ? 'Guardando...'
                        : (editandoHistorial?.id ? 'Guardar cambios' : 'Agregar registro')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Tab: Expediente laboral */}
          {activeTab === 'expediente' && expedienteLaboralActivo && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-slate-50 to-slate-100 px-6 py-4 border-b border-slate-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-slate-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">🗂️</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Expediente laboral</h3>
                    <p className="text-gray-600 text-sm">Documentos del trabajador y alertas de vencimiento</p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <ExpedienteLaboralTab
                  empleadoId={empleado?.id || null}
                  empresaId={selectedCompany?.id || null}
                />
              </div>
            </div>
          )}

          {activeTab === 'ssoma' && ssomaActivo && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-teal-50 to-emerald-50 px-6 py-4 border-b border-teal-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">🛡️</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">SSOMA</h3>
                    <p className="text-gray-600 text-sm">Tallas de pantalón, polo y zapatos para el área SSOMA</p>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <SsomaTallasTab
                  empresaId={selectedCompany?.id || null}
                  empleadoId={empleado?.id || null}
                />
              </div>
            </div>
          )}

          {/* Tab: Remuneración y Aportes */}
          {activeTab === 'remuneracion' && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 px-6 py-4 border-b border-yellow-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">💰</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-yellow-900">Remuneración y Aportes</h3>
                    <p className="text-yellow-600 text-sm">Conceptos salariales, beneficios y descuentos</p>
                  </div>
                </div>
              </div>
              
              <div className="p-6 space-y-6">
                {/* Mensaje de bloqueo si no hay tipo de contratación */}
                {!formData.tipoContratacion ? (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-8 text-center">
                    <div className="flex flex-col items-center space-y-4">
                      <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                        <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-yellow-800 mb-2">Selecciona el Tipo de Contratación</h3>
                        <p className="text-yellow-700">
                          Para configurar la remuneración, primero debes seleccionar el tipo de contratación en la pestaña <strong>"Laboral"</strong>.
                        </p>
                        <button
                          type="button"
                          onClick={() => setActiveTab('laboral')}
                          className="mt-4 bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 transition-colors flex items-center space-x-2 mx-auto"
                        >
                          <span>Ir a Información Laboral</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* Sección Superior: Aportes y Fecha de Ingreso */}
                    <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                      <div className="space-y-4">
                      {!esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales) && (
                        <div className="flex flex-wrap items-center justify-between gap-3 pb-4 border-b border-gray-200">
                          <div>
                            <p className="text-sm font-semibold text-teal-700">Forma de pago</p>
                            <p className="text-xs text-gray-500 mt-0.5">
                              {formData.formaPago === 'jornal'
                                ? 'Se paga por día asistido o de descanso: la plantilla se divide entre los días del mes. Faltas y permisos no se descuentan aparte. Dominical y tardanzas se ven en planilla y se restan del 0121 al declarar.'
                                : 'Sueldo mensual prorrateado a 30 días. Faltas y permisos van a inasistencias. Si el dominical está activo, se ve aparte y en PLAME se suma al 0705.'}
                            </p>
                          </div>
                          <div className="inline-flex rounded-lg border border-gray-300 bg-white p-0.5 shadow-sm">
                            <button
                              type="button"
                              onClick={() => handleInputChange('formaPago', 'mensual')}
                              className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
                                formData.formaPago !== 'jornal'
                                  ? 'bg-teal-600 text-white shadow'
                                  : 'text-gray-600 hover:text-gray-900'
                              }`}
                            >
                              Mensual
                            </button>
                            <button
                              type="button"
                              onClick={() => handleInputChange('formaPago', 'jornal')}
                              className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
                                formData.formaPago === 'jornal'
                                  ? 'bg-teal-600 text-white shadow'
                                  : 'text-gray-600 hover:text-gray-900'
                              }`}
                            >
                              Jornal
                            </button>
                          </div>
                        </div>
                      )}
                        {/* Todos los campos en una línea horizontal */}
                        <div className="flex flex-wrap items-end gap-4">
                      {/* ONP/AFP solo cuando hay PLAME (dual o sin planilla alternativa) */}
                      {formData.tipoContratacion !== 'Recibo por Honorarios' &&
                        !(planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna') && (
                        <>
                          <div className="space-y-2">
                            <label className="block text-sm font-semibold text-teal-700">Aporte:</label>
                            <select
                              value={formData.sistemaPensionario}
                              onChange={(e) => handleInputChange('sistemaPensionario', e.target.value)}
                              className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm"
                            >
                              <option value="ONP">ONP</option>
                              <option value="AFP">AFP</option>
                            </select>
                          </div>
                          
                          {formData.sistemaPensionario === 'AFP' && (
                            <>
                              <div className="space-y-2">
                                <label className="block text-sm font-semibold text-gray-700">AFP:</label>
                                <select
                                  value={formData.afp}
                                  onChange={(e) => handleInputChange('afp', e.target.value)}
                                  className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm"
                                >
                                  <option value="">Seleccionar...</option>
                                  {afps.map(afp => (
                                    <option key={afp} value={afp}>{afp}</option>
                                  ))}
                                </select>
                              </div>
                              
                              <div className="space-y-2">
                                <label className="block text-sm font-semibold text-gray-700">Tipo de AFP:</label>
                                <select
                                  value={formData.tipoAfp || 'Flujo'}
                                  onChange={(e) => handleInputChange('tipoAfp', e.target.value)}
                                  className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm"
                                >
                                  <option value="Flujo">Flujo</option>
                                  <option value="Mixto">Mixto</option>
                                </select>
                              </div>
                              
                              <div className="space-y-2">
                                <label className="block text-sm font-semibold text-gray-700">CUSPP:</label>
                                <input
                                  type="text"
                                  value={formData.cuspp}
                                  onChange={(e) => handleInputChange('cuspp', e.target.value)}
                                  className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm"
                                  placeholder="Código CUSPP"
                                />
                              </div>
                            </>
                          )}
                        </>
                      )}
                      
                      {/* Sueldo declarado PLAME: no aplica a CONSU (usa jornal diario) */}
                      {!esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales)
                        && (!planillaAlternativaActiva || formData.tipoPlanilla === 'dual') && (
                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-teal-700">
                            {planillaAlternativaActiva
                              ? (formData.tipoContratacion === 'Recibo por Honorarios'
                                  ? 'Monto honorarios (PLAME):'
                                  : 'Sueldo declarado (PLAME):')
                              : (formData.tipoContratacion === 'Recibo por Honorarios'
                                  ? 'Monto por Honorarios:'
                                  : 'Sueldo Básico:')}
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={formData.sueldoBasico}
                            onChange={(e) => handleInputChange('sueldoBasico', e.target.value)}
                              className={`pl-8 pr-3 py-2 border rounded focus:outline-none focus:border-teal-500 text-sm w-32 ${
                                errors.sueldoBasico ? 'border-red-300 bg-red-50' : 'border-gray-300'
                              }`}
                            placeholder="0.00"
                          />
                        </div>
                          {errors.sueldoBasico && (
                            <p className="text-red-500 text-xs">{errors.sueldoBasico}</p>
                          )}
                      </div>
                      )}

                      {planillaAlternativaActiva && (
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-teal-700">
                            Sueldo interno (control):
                          </label>
                          <div className="relative">
                            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              value={formData.sueldoInterno}
                              onChange={(e) => handleInputChange('sueldoInterno', e.target.value)}
                              className={`pl-8 pr-3 py-2 border rounded focus:outline-none focus:border-teal-500 text-sm w-32 ${
                                errors.sueldoInterno ? 'border-red-300 bg-red-50' : 'border-gray-300'
                              }`}
                              placeholder="0.00"
                            />
                          </div>
                          {errors.sueldoInterno && (
                            <p className="text-red-500 text-xs">{errors.sueldoInterno}</p>
                          )}
                        </div>
                      )}
                      
                      {/* Régimen Laboral - Solo si NO es Recibo por Honorarios */}
                      {formData.tipoContratacion !== 'Recibo por Honorarios' && (
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-teal-700">Régimen Laboral:</label>
                          <select
                            value={formData.regimenLaboral || ''}
                            onChange={(e) => handleInputChange('regimenLaboral', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm w-40"
                            disabled={loadingRegimenes}
                          >
                            <option value="">{loadingRegimenes ? 'Cargando...' : 'Seleccionar...'}</option>
                            {regimenesLaborales.map(regimen => (
                              <option key={regimen.id} value={regimen.nombre}>
                                {regimen.nombre}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      {formData.tipoContratacion !== 'Recibo por Honorarios'
                        && esRegimenConstruccionCivil(formData.regimenLaboral, regimenesLaborales) && (
                        <ConstruccionCivilFichaEmpleado
                          ficha={fichaConsu}
                          onChange={setFichaConsu}
                        />
                      )}

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-transparent">Acciones:</label>
                        <button
                          type="button"
                          onClick={handleGenerar}
                          disabled={!validarCamposGenerar()}
                          className={`px-6 py-2 font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 transition-all shadow-md ${
                            validarCamposGenerar()
                              ? 'bg-gradient-to-r from-teal-600 to-teal-700 text-white hover:from-teal-700 hover:to-teal-800 cursor-pointer'
                              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          }`}
                        >
                          Generar
                        </button>
                      </div>
                      
                      {/* Configuración adicional - Solo si NO es Recibo por Honorarios */}
                      {formData.tipoContratacion !== 'Recibo por Honorarios' && (
                        <div className="space-y-2 col-span-full">
                          <label className="block text-sm font-semibold text-teal-700 mb-3">
                            <span className="flex items-center space-x-2">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                              <span>Configuración Adicional</span>
                            </span>
                          </label>
                          
                                                     <div className="bg-gradient-to-br from-teal-50 to-cyan-50 border border-teal-200 rounded-lg p-3 sm:p-4">
                             <div className="flex flex-col sm:grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4">
                              
                              {/* Asignación Familiar */}
                              <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                                <label className="flex items-center space-x-2 sm:space-x-3 cursor-pointer group">
                                  <div className="relative">
                                    <input
                                      type="checkbox"
                                      checked={formData.asignacionFamiliar}
                                      onChange={(e) => handleInputChange('asignacionFamiliar', e.target.checked)}
                                      className="h-5 w-5 text-teal-600 focus:ring-teal-500 border-gray-300 rounded transition-colors"
                                    />
                                    {formData.asignacionFamiliar && (
                                      <svg className="absolute inset-0 h-5 w-5 text-teal-600 pointer-events-none" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center space-x-2">
                                      <span className="text-xl sm:text-2xl">👨‍👩‍👧‍👦</span>
                                      <span className="text-sm sm:text-sm font-medium text-gray-800 group-hover:text-teal-700 transition-colors truncate">
                                        Asignación Familiar
                                      </span>
                                    </div>
                                  </div>
                                </label>
                              </div>

                              {/* Bono */}
                              <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                                <label className="flex items-center space-x-2 sm:space-x-3 cursor-pointer group">
                                  <div className="relative">
                                    <input
                                      type="checkbox"
                                      checked={formData.tieneBono}
                                      onChange={(e) => handleInputChange('tieneBono', e.target.checked)}
                                      className="h-5 w-5 text-teal-600 focus:ring-teal-500 border-gray-300 rounded transition-colors"
                                    />
                                    {formData.tieneBono && (
                                      <svg className="absolute inset-0 h-5 w-5 text-teal-600 pointer-events-none" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center space-x-2">
                                      <span className="text-xl sm:text-2xl">💰</span>
                                      <span className="text-sm sm:text-sm font-medium text-gray-800 group-hover:text-teal-700 transition-colors truncate">
                                        Tiene Bono
                                      </span>
                                    </div>
                                  </div>
                                </label>
                                
                                {/* Input de monto del bono con animación */}
                                <div className={`transition-all duration-300 ease-in-out overflow-hidden ${
                                  formData.tieneBono ? 'max-h-24 sm:max-h-20 opacity-100 mt-2 sm:mt-3' : 'max-h-0 opacity-0'
                                }`}>
                                  <div className="bg-gray-50 rounded-md p-2 border border-gray-200">
                                    <div className="flex flex-col sm:flex-row sm:items-center space-y-1 sm:space-y-0 sm:space-x-2">
                                      <span className="text-xs font-medium text-gray-600 whitespace-nowrap">Monto:</span>
                                      <div className="relative flex-1">
                                        <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs font-semibold">S/</span>
                                        <input
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          value={formData.montoBono}
                                          onChange={(e) => handleInputChange('montoBono', e.target.value)}
                                          className="w-full pl-6 pr-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-all"
                                          placeholder="0.00"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Viático standard (solo si está habilitado en Configuración) */}
                              {viaticosStandardActivo && (
                                <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                                  <div className="flex items-center space-x-2 mb-2">
                                    <span className="text-xl sm:text-2xl">🧳</span>
                                    <span className="text-sm font-medium text-gray-800">
                                      Viático standard (esperado)
                                    </span>
                                  </div>
                                  <p className="text-xs text-gray-500 mb-2">
                                    Monto que debería recibir, para comparar con lo entregado en la realidad.
                                  </p>
                                  <div className="bg-gray-50 rounded-md p-2 border border-gray-200">
                                    <div className="flex flex-col sm:flex-row sm:items-center space-y-1 sm:space-y-0 sm:space-x-2">
                                      <span className="text-xs font-medium text-gray-600 whitespace-nowrap">Monto:</span>
                                      <div className="relative flex-1">
                                        <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs font-semibold">S/</span>
                                        <input
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          value={formData.montoViaticoStandard}
                                          onChange={(e) => handleInputChange('montoViaticoStandard', e.target.value)}
                                          className="w-full pl-6 pr-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-all"
                                          placeholder="0.00"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Boleta Liquidada */}
                              <div className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                                <label className="flex items-center space-x-2 sm:space-x-3 cursor-pointer group">
                                  <div className="relative">
                                    <input
                                      type="checkbox"
                                      checked={formData.esBoletaLiquidada}
                                      onChange={(e) => handleInputChange('esBoletaLiquidada', e.target.checked)}
                                      className="h-5 w-5 text-teal-600 focus:ring-teal-500 border-gray-300 rounded transition-colors"
                                    />
                                    {formData.esBoletaLiquidada && (
                                      <svg className="absolute inset-0 h-5 w-5 text-teal-600 pointer-events-none" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center space-x-2">
                                      <span className="text-xl sm:text-2xl">📄</span>
                                      <span className="text-sm sm:text-sm font-medium text-gray-800 group-hover:text-teal-700 transition-colors truncate">
                                        Boleta Liquidada
                                      </span>
                                    </div>
                                  </div>
                                </label>
                              </div>

                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Sección Principal: Columnas dinámicas según tipo de contratación */}
                <div className={`grid grid-cols-1 gap-6 ${
                  formData.tipoContratacion === 'Recibo por Honorarios' ||
                  (planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna')
                    ? 'lg:grid-cols-1' 
                    : 'lg:grid-cols-3'
                }`}>
                  {/* Columna 1: Ingresos (PLAME o solo interna) */}
                  <div className="bg-white border border-gray-300 rounded-lg">
                    <div className="bg-green-100 px-4 py-3 border-b border-gray-300 flex justify-between items-center">
                      <h4 className="font-bold text-green-800">
                        {planillaAlternativaActiva && formData.tipoPlanilla === 'dual'
                          ? 'Ingresos PLAME:'
                          : planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna'
                            ? 'Ingresos internos (control):'
                            : 'Ingresos:'}
                      </h4>
                      <button
                        type="button"
                        onClick={() => agregarConcepto('ingresos')}
                        className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 transition-colors flex items-center space-x-1"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        <span>Agregar</span>
                      </button>
                    </div>
                    <div className="p-4 space-y-3">
                      {formData.ingresos.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                          <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          <p className="text-sm">No hay conceptos de ingresos</p>
                          <p className="text-xs text-gray-400 mt-1">Haz clic en "Agregar" para buscar códigos PLAME</p>
                        </div>
                      ) : (
                        formData.ingresos.map((ingreso, index) => {
                          const key = `ingresos_${index}`;
                          const estaEditando = editandoConcepto[key];
                          
                          return (
                            <div key={ingreso.id} className="space-y-2 border-b border-gray-100 pb-3 last:border-b-0">
                              <div className="flex justify-between items-start">
                                <div className="flex-1">
                                  <div className="flex items-center space-x-2">
                                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded font-mono">
                                      {ingreso.codigoPlame}
                                    </span>
                                    <button
                                      type="button"
                                      onClick={() => handleEliminarConcepto('ingresos', ingreso.id)}
                                      className="text-red-500 hover:text-red-700 p-1"
                                      title="Eliminar concepto"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                      </svg>
                                    </button>
                                  </div>
                                  <p className="text-sm font-medium text-gray-700 mt-1">{ingreso.concepto}</p>
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                <div className="relative flex-1">
                                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    value={ingreso.monto}
                                    onChange={(e) => actualizarConcepto('ingresos', ingreso.id, 'monto', e.target.value)}
                                    readOnly={!estaEditando}
                                    className={`w-full pl-8 pr-3 py-2 border rounded text-sm ${
                                      estaEditando
                                        ? 'border-gray-300 focus:outline-none focus:border-green-500 bg-white'
                                        : 'border-gray-200 bg-gray-50 text-gray-700 cursor-not-allowed'
                                    }`}
                                    placeholder="0.00"
                                  />
                                </div>
                                
                                {/* Botones de edición individual */}
                                {!estaEditando ? (
                                  <button
                                    type="button"
                                    onClick={() => iniciarEdicionConcepto('ingresos', index)}
                                    className="text-gray-500 hover:text-blue-600 p-1 transition-colors"
                                    title="Editar monto"
                                  >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                  </button>
                                ) : (
                                  <div className="flex items-center space-x-1">
                                    <button
                                      type="button"
                                      onClick={() => guardarCambiosConcepto('ingresos', index)}
                                      className="text-green-600 hover:text-green-700 p-1 transition-colors"
                                      title="Guardar cambios"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => cancelarEdicionConcepto('ingresos', index)}
                                      className="text-gray-500 hover:text-red-600 p-1 transition-colors"
                                      title="Cancelar edición"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                      </svg>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>

                  {/* Columnas 2 y 3: Descuentos y Aportes — solo con PLAME (no solo_interna / no RH) */}
                  {formData.tipoContratacion !== 'Recibo por Honorarios' &&
                    !(planillaAlternativaActiva && formData.tipoPlanilla === 'solo_interna') && (
                    <>
                      {/* Columna 2: Descuentos */}
                      <div className="bg-white border border-gray-300 rounded-lg">
                        <div className="bg-red-100 px-4 py-3 border-b border-gray-300 flex justify-between items-center">
                          <h4 className="font-bold text-red-800">
                            {planillaAlternativaActiva && formData.tipoPlanilla === 'dual'
                              ? 'Descuentos PLAME:'
                              : 'Descuentos:'}
                          </h4>
                          <button
                            type="button"
                            onClick={() => agregarConcepto('descuentos')}
                            className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700 transition-colors flex items-center space-x-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            <span>Agregar</span>
                          </button>
                        </div>
                        <div className="p-4 space-y-3">
                          {formData.descuentos.length === 0 ? (
                            <div className="text-center py-8 text-gray-500">
                              <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                              <p className="text-sm">No hay conceptos de descuentos</p>
                              <p className="text-xs text-gray-400 mt-1">Haz clic en "Agregar" para buscar códigos PLAME</p>
                            </div>
                          ) : (
                            formData.descuentos.map((descuento, index) => {
                              const key = `descuentos_${index}`;
                              const estaEditando = editandoConcepto[key];
                              
                              return (
                                <div key={descuento.id} className="space-y-2 border-b border-gray-100 pb-3 last:border-b-0">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-2">
                                        <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded font-mono">
                                          {descuento.codigoPlame}
                                        </span>
                                        <button
                                          type="button"
                                          onClick={() => handleEliminarConcepto('descuentos', descuento.id)}
                                          className="text-red-500 hover:text-red-700 p-1"
                                          title="Eliminar concepto"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                          </svg>
                                        </button>
                                      </div>
                                      <p className="text-sm font-medium text-gray-700 mt-1">{descuento.concepto}</p>
                                    </div>
                                  </div>
                                  
                                  <div className="flex items-center space-x-2">
                                    <div className="relative flex-1">
                                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                                      <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={descuento.monto}
                                        onChange={(e) => actualizarConcepto('descuentos', descuento.id, 'monto', e.target.value)}
                                        readOnly={!estaEditando}
                                        className={`w-full pl-8 pr-3 py-2 border rounded text-sm ${
                                          estaEditando
                                            ? 'border-gray-300 focus:outline-none focus:border-red-500 bg-white'
                                            : 'border-gray-200 bg-gray-50 text-gray-700 cursor-not-allowed'
                                        }`}
                                        placeholder="0.00"
                                      />
                                    </div>
                                    
                                    {/* Botones de edición individual */}
                                    {!estaEditando ? (
                                      <button
                                        type="button"
                                        onClick={() => iniciarEdicionConcepto('descuentos', index)}
                                        className="text-gray-500 hover:text-blue-600 p-1 transition-colors"
                                        title="Editar monto"
                                      >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                      </button>
                                    ) : (
                                      <div className="flex items-center space-x-1">
                                        <button
                                          type="button"
                                          onClick={() => guardarCambiosConcepto('descuentos', index)}
                                          className="text-green-600 hover:text-green-700 p-1 transition-colors"
                                          title="Guardar cambios"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                          </svg>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => cancelarEdicionConcepto('descuentos', index)}
                                          className="text-gray-500 hover:text-red-600 p-1 transition-colors"
                                          title="Cancelar edición"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                          </svg>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>

                      {/* Columna 3: Aportes */}
                      <div className="bg-white border border-gray-300 rounded-lg">
                        <div className="bg-blue-100 px-4 py-3 border-b border-gray-300 flex justify-between items-center">
                          <h4 className="font-bold text-blue-800">
                            {planillaAlternativaActiva && formData.tipoPlanilla === 'dual'
                              ? 'Aportes PLAME:'
                              : 'Aportes:'}
                          </h4>
                          <button
                            type="button"
                            onClick={() => agregarConcepto('aportes')}
                            className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 transition-colors flex items-center space-x-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            <span>Agregar</span>
                          </button>
                        </div>
                        <div className="p-4 space-y-3">
                          {formData.aportes.length === 0 ? (
                            <div className="text-center py-8 text-gray-500">
                              <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                              <p className="text-sm">No hay conceptos de aportes</p>
                              <p className="text-xs text-gray-400 mt-1">Haz clic en "Agregar" para buscar códigos PLAME</p>
                            </div>
                          ) : (
                            formData.aportes.map((aporte, index) => {
                              const key = `aportes_${index}`;
                              const estaEditando = editandoConcepto[key];
                              
                              return (
                                <div key={aporte.id} className="space-y-2 border-b border-gray-100 pb-3 last:border-b-0">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      <div className="flex items-center space-x-2">
                                        <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded font-mono">
                                          {aporte.codigoPlame}
                                        </span>
                                        <button
                                          type="button"
                                          onClick={() => handleEliminarConcepto('aportes', aporte.id)}
                                          className="text-red-500 hover:text-red-700 p-1"
                                          title="Eliminar concepto"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                          </svg>
                                        </button>
                                      </div>
                                      <p className="text-sm font-medium text-gray-700 mt-1">{aporte.concepto}</p>
                                    </div>
                                  </div>
                                  
                                  <div className="flex items-center space-x-2">
                                    <div className="relative flex-1">
                                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                                      <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={aporte.monto}
                                        onChange={(e) => actualizarConcepto('aportes', aporte.id, 'monto', e.target.value)}
                                        readOnly={!estaEditando}
                                        className={`w-full pl-8 pr-3 py-2 border rounded text-sm ${
                                          estaEditando
                                            ? 'border-gray-300 focus:outline-none focus:border-blue-500 bg-white'
                                            : 'border-gray-200 bg-gray-50 text-gray-700 cursor-not-allowed'
                                        }`}
                                        placeholder="0.00"
                                      />
                                    </div>
                                    
                                    {/* Botones de edición individual */}
                                    {!estaEditando ? (
                                      <button
                                        type="button"
                                        onClick={() => iniciarEdicionConcepto('aportes', index)}
                                        className="text-gray-500 hover:text-blue-600 p-1 transition-colors"
                                        title="Editar monto"
                                      >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                      </button>
                                    ) : (
                                      <div className="flex items-center space-x-1">
                                        <button
                                          type="button"
                                          onClick={() => guardarCambiosConcepto('aportes', index)}
                                          className="text-green-600 hover:text-green-700 p-1 transition-colors"
                                          title="Guardar cambios"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                          </svg>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => cancelarEdicionConcepto('aportes', index)}
                                          className="text-gray-500 hover:text-red-600 p-1 transition-colors"
                                          title="Cancelar edición"
                                        >
                                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                          </svg>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Dual: boleta interna con mismas 3 columnas (desc/aportes vacíos al generar) */}
                {planillaAlternativaActiva &&
                  formData.tipoPlanilla === 'dual' &&
                  formData.tipoContratacion !== 'Recibo por Honorarios' && (
                  <div className="mt-6 rounded-xl border border-amber-200 overflow-hidden">
                    <div className="bg-gradient-to-r from-amber-50 to-amber-100 px-4 py-3 border-b border-amber-200">
                      <h4 className="font-bold text-amber-950">Boleta interna (control)</h4>
                      <p className="text-xs text-amber-800/80">
                        Ingresos con sueldo interno (agregar aquí no afecta descuentos). Los códigos de esta boleta se quedan aquí; los de PLAME en PLAME. Solo ONP/AFP, EsSalud y minera se copian desde PLAME a ambas.
                      </p>
                    </div>
                    <div className="p-4 grid grid-cols-1 gap-6 lg:grid-cols-3 bg-white">
                      {[
                        {
                          tipo: 'ingresosInternos',
                          titulo: 'Ingresos:',
                          headerBg: 'bg-green-100',
                          headerText: 'text-green-800',
                          badge: 'bg-green-100 text-green-800',
                          btn: 'bg-green-600 hover:bg-green-700',
                          focusEdit: 'focus:border-green-500',
                          vacio: 'No hay conceptos de ingresos',
                        },
                        {
                          tipo: 'descuentosInternos',
                          titulo: 'Descuentos:',
                          headerBg: 'bg-red-100',
                          headerText: 'text-red-800',
                          badge: 'bg-red-100 text-red-800',
                          btn: 'bg-red-600 hover:bg-red-700',
                          focusEdit: 'focus:border-red-500',
                          vacio: 'No hay conceptos de descuentos',
                        },
                        {
                          tipo: 'aportesInternos',
                          titulo: 'Aportes:',
                          headerBg: 'bg-blue-100',
                          headerText: 'text-blue-800',
                          badge: 'bg-blue-100 text-blue-800',
                          btn: 'bg-blue-600 hover:bg-blue-700',
                          focusEdit: 'focus:border-blue-500',
                          vacio: 'No hay conceptos de aportes',
                        },
                      ].map((col) => {
                        const lista = formData[col.tipo] || [];
                        return (
                          <div key={col.tipo} className="bg-white border border-gray-300 rounded-lg">
                            <div className={`${col.headerBg} px-4 py-3 border-b border-gray-300 flex justify-between items-center`}>
                              <h4 className={`font-bold ${col.headerText}`}>{col.titulo}</h4>
                              <button
                                type="button"
                                onClick={() => agregarConcepto(col.tipo)}
                                className={`${col.btn} text-white px-3 py-1 rounded text-sm transition-colors flex items-center space-x-1`}
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                <span>Agregar</span>
                              </button>
                            </div>
                            <div className="p-4 space-y-3">
                              {lista.length === 0 ? (
                                <div className="text-center py-8 text-gray-500">
                                  <p className="text-sm">{col.vacio}</p>
                                  <p className="text-xs text-gray-400 mt-1">
                                    {col.tipo === 'ingresosInternos'
                                      ? 'Pulsa Generar o Agregar'
                                      : 'Se copian desde PLAME al generar (ONP/AFP, EsSalud, minera)'}
                                  </p>
                                </div>
                              ) : (
                                lista.map((item, index) => {
                                  const key = `${col.tipo}_${index}`;
                                  const estaEditando = editandoConcepto[key];
                                  return (
                                    <div key={item.id} className="space-y-2 border-b border-gray-100 pb-3 last:border-b-0">
                                      <div className="flex justify-between items-start">
                                        <div className="flex-1">
                                          <div className="flex items-center space-x-2">
                                            <span className={`${col.badge} text-xs px-2 py-1 rounded font-mono`}>
                                              {item.codigoPlame}
                                            </span>
                                            <button
                                              type="button"
                                              onClick={() => handleEliminarConcepto(col.tipo, item.id)}
                                              className="text-red-500 hover:text-red-700 p-1"
                                              title="Eliminar concepto"
                                            >
                                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                              </svg>
                                            </button>
                                          </div>
                                          <p className="text-sm font-medium text-gray-700 mt-1">{item.concepto}</p>
                                        </div>
                                      </div>
                                      <div className="flex items-center space-x-2">
                                        <div className="relative flex-1">
                                          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                                          <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            value={item.monto}
                                            onChange={(e) => actualizarConcepto(col.tipo, item.id, 'monto', e.target.value)}
                                            readOnly={!estaEditando}
                                            className={`w-full pl-8 pr-3 py-2 border rounded text-sm ${
                                              estaEditando
                                                ? `border-gray-300 focus:outline-none ${col.focusEdit} bg-white`
                                                : 'border-gray-200 bg-gray-50 text-gray-700 cursor-not-allowed'
                                            }`}
                                            placeholder="0.00"
                                          />
                                        </div>
                                        {!estaEditando ? (
                                          <button
                                            type="button"
                                            onClick={() => iniciarEdicionConcepto(col.tipo, index)}
                                            className="text-gray-500 hover:text-blue-600 p-1 transition-colors"
                                            title="Editar monto"
                                          >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                          </button>
                                        ) : (
                                          <div className="flex items-center space-x-1">
                                            <button
                                              type="button"
                                              onClick={() => {
                                                setEditandoConcepto((prev) => ({ ...prev, [key]: false }));
                                              }}
                                              className="text-green-600 hover:text-green-700 p-1 transition-colors"
                                              title="Guardar"
                                            >
                                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                              </svg>
                                            </button>
                                            <button
                                              type="button"
                                              onClick={() => cancelarEdicionConcepto(col.tipo, index)}
                                              className="text-gray-500 hover:text-red-600 p-1 transition-colors"
                                              title="Cancelar"
                                            >
                                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                              </svg>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                </>
                )}
              </div>
            </div>
          )}

          {/* Tab: Horarios */}
          {activeTab === 'horarios' && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-indigo-50 to-indigo-100 px-6 py-4 border-b border-indigo-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-indigo-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">⏰</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-indigo-900">Horarios de Trabajo</h3>
                    <p className="text-indigo-600 text-sm">Configuración de horarios y días laborales</p>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="space-y-6">
                  {/* Configuración de Horarios Simplificada */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
                    <div className="space-y-2">
                      <label className="block text-sm font-semibold text-gray-700">
                        Hora de Entrada <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                      <input
                        type="time"
                        value={formData.horaEntrada}
                        onChange={(e) => handleInputChange('horaEntrada', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-indigo-500 bg-white text-lg"
                          required
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-semibold text-gray-700">
                        Hora de Salida <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                      <input
                        type="time"
                        value={formData.horaSalida}
                        onChange={(e) => handleInputChange('horaSalida', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-indigo-500 bg-white text-lg"
                          required
                      />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                    </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          )}

          {/* Tab: Información Adicional */}
          {activeTab === 'adicional' && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-gray-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">📋</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Información Adicional</h3>
                    <p className="text-gray-600 text-sm">Datos bancarios y contactos de emergencia</p>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="space-y-8">
                  {/* Información Bancaria */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-2">
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                      </svg>
                      <h4 className="text-lg font-semibold text-gray-900">Información Bancaria</h4>
                    </div>
                    <p className="text-sm font-medium text-gray-600">Cuenta de haberes (planilla)</p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Banco</label>
                        <select
                          value={formData.banco}
                          onChange={(e) => handleInputChange('banco', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                        >
                          <option value="">Seleccionar banco...</option>
                          {bancos.map(banco => (
                            <option key={banco} value={banco}>{banco}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Cuenta Bancaria</label>
                        <input
                          type="text"
                          value={formData.cuentaBancaria}
                          onChange={(e) => handleInputChange('cuentaBancaria', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                          placeholder="Número de cuenta"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">CCI</label>
                        <input
                          type="text"
                          value={formData.cci}
                          onChange={(e) => handleInputChange('cci', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                          placeholder="Código CCI"
                        />
                      </div>
                    </div>

                    <p className="text-sm font-medium text-gray-600 pt-2">Depósito CTS</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Banco CTS</label>
                        <select
                          value={formData.bancoCts}
                          onChange={(e) => handleInputChange('bancoCts', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                        >
                          <option value="">Seleccionar banco...</option>
                          {bancos.map((banco) => (
                            <option key={`cts-${banco}`} value={banco}>
                              {banco}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Cuenta CTS</label>
                        <input
                          type="text"
                          value={formData.cuentaCts}
                          onChange={(e) => handleInputChange('cuentaCts', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                          placeholder="Número de cuenta CTS"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Contacto de Emergencia */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-2">
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                      <h4 className="text-lg font-semibold text-gray-900">Contacto de Emergencia</h4>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Nombre del Contacto</label>
                        <input
                          type="text"
                          value={formData.contactoEmergencia}
                          onChange={(e) => handleInputChange('contactoEmergencia', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                          placeholder="Nombre completo"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">Teléfono de Emergencia</label>
                        <input
                          type="tel"
                          value={formData.telefonoEmergencia}
                          onChange={(e) => handleInputChange('telefonoEmergencia', e.target.value)}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white"
                          placeholder="Número de teléfono"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Observaciones */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-2">
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <h4 className="text-lg font-semibold text-gray-900">Observaciones</h4>
                    </div>
                    <div className="space-y-2">
                      <textarea
                        rows={4}
                        value={formData.observaciones}
                        onChange={(e) => handleInputChange('observaciones', e.target.value)}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-gray-500 bg-white resize-none"
                        placeholder="Observaciones adicionales sobre el empleado..."
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Botones de acción fijos en la parte inferior */}
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-8 py-4 shadow-lg">
          <div className="max-w-7xl mx-auto">
            {/* Mensajes de estado - Centrados */}
            {mensajeExito && (
              <div className="mb-4 bg-green-50 border border-green-200 rounded-lg p-4 mx-auto max-w-2xl">
                <div className="flex items-center justify-center">
                  <svg className="w-5 h-5 text-green-600 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-green-800 font-medium text-center">{mensajeExito}</span>
                </div>
              </div>
            )}
            
            {mensajeError && (
              <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4 mx-auto max-w-2xl">
                <div className="flex items-center justify-center">
                  <svg className="w-5 h-5 text-red-600 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-red-800 font-medium text-center">{mensajeError}</span>
                </div>
              </div>
            )}
            
            <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onCancel}
              className="px-8 py-3 border-2 border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading || guardandoEmpleado}
              className="px-8 py-3 bg-gradient-to-r from-teal-600 to-teal-700 text-white font-medium rounded-lg hover:from-teal-700 hover:to-teal-800 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg"
            >
              {isLoading || guardandoEmpleado ? (
                <span className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  {guardandoEmpleado ? 'Guardando empleado...' : 'Guardando...'}
                </span>
              ) : (
                empleado ? 'Actualizar Empleado' : 'Crear Empleado'
              )}
            </button>
            </div>
          </div>
        </div>
      </form>

      {/* Modal Buscador PLAME */}
      {buscadorVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r from-teal-600 to-teal-700 px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-white">
                Buscar Códigos PLAME -{' '}
                {tipoConceptoActual === 'ingresosInternos'
                  ? 'Ingresos internos'
                  : tipoConceptoActual === 'descuentosInternos'
                    ? 'Descuentos internos'
                    : tipoConceptoActual === 'aportesInternos'
                      ? 'Aportes internos'
                      : tipoConceptoActual.charAt(0).toUpperCase() + tipoConceptoActual.slice(1)}
              </h3>
              <button
                onClick={() => {
                  setBuscadorVisible(false);
                  setTerminoBusqueda('');
                  setResultadosBusqueda([]);
                  setTipoConceptoActual('');
                  setConceptoSeleccionado(null);
                  setMontoModal('');
                  setFormulasDisponibles([]);
                  setFormulaSeleccionada(null);
                  setCalculoFormula(null);
                  setMostrarFormulas(false);
                }}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto">
            <div className="p-6">
              {/* Campo de búsqueda */}
              <div className="mb-4">
                <div className="relative">
                  <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <input
                    type="text"
                    value={terminoBusqueda}
                    onChange={(e) => buscarCodigosPlame(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-500"
                    placeholder={`Buscar ${tipoConceptoActual} por código o descripción...`}
                    autoFocus
                  />
                </div>
              </div>

              {/* Indicador de carga */}
              {loadingPlame && (
                <div className="flex items-center justify-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-3 text-gray-600">Cargando códigos PLAME...</span>
                </div>
              )}

              {/* Resultados de búsqueda */}
                <div className="space-y-3 max-h-64 overflow-y-auto">
                              {!loadingPlame && resultadosBusqueda.length === 0 && (
                <div className="text-center py-8 text-gray-500">
                  <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <p>
                    {terminoBusqueda 
                      ? `No se encontraron códigos de ${tipoConceptoActual}` 
                      : `Buscar códigos de ${tipoConceptoActual}`
                    }
                  </p>
                  <p className="text-sm text-gray-400 mt-1">
                    {terminoBusqueda 
                      ? 'Intenta con otros términos de búsqueda' 
                      : 'Escribe el código o descripción para buscar'
                    }
                  </p>
                </div>
              )}

                {resultadosBusqueda.map((codigo) => (
                  <div
                    key={codigo.id}
                    onClick={() => seleccionarConceptoPlame(codigo)}
                    className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
                      conceptoSeleccionado?.id === codigo.id
                        ? 'border-teal-500 bg-teal-50'
                        : 'border-gray-200 hover:bg-blue-50 hover:border-blue-300'
                    }`}
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded font-mono font-bold">
                            {codigo.codigo}
                          </span>
                          {codigo.clasificacion && (
                            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                              {codigo.clasificacion.descripcion}
                            </span>
                          )}
                        </div>
                        <h4 className="font-medium text-gray-900 mb-2">{codigo.descripcion}</h4>
                        
                        {/* Afectaciones */}
                        <div className="flex flex-wrap gap-1">
                          {codigo.afectaciones.essalud_regular && (
                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">EsSalud Regular</span>
                          )}
                          {codigo.afectaciones.essalud_cbssp_seg && (
                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">EsSalud CBSSP</span>
                          )}
                          {codigo.afectaciones.essalud_agrario && (
                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">EsSalud Agrario</span>
                          )}
                          {codigo.afectaciones.essalud_sctr && (
                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">EsSalud SCTR</span>
                          )}
                          {codigo.afectaciones.sistema_nacional_19990 && (
                            <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">SNP</span>
                          )}
                          {codigo.afectaciones.sistema_privado_pension && (
                            <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">SPP</span>
                          )}
                          {codigo.afectaciones.renta_5ta_categoria && (
                            <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded">Renta 5ta</span>
                          )}
                          {codigo.afectaciones.senati && (
                            <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">SENATI</span>
                          )}
                          {codigo.afectaciones.impuesto_extraord_solid && (
                            <span className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded">Imp. Extraord.</span>
                          )}
                          {codigo.afectaciones.fondo_derechos_artista && (
                            <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Fondo Artista</span>
                          )}
                          {codigo.afectaciones.fondo_compl_jubil && (
                            <span className="text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded">Fondo Jubil.</span>
                          )}
                          {codigo.afectaciones.reg_esp_pensiones_pesq && (
                            <span className="text-xs bg-teal-100 text-teal-800 px-2 py-1 rounded">Reg. Pesq.</span>
                          )}
                          {codigo.afectaciones.essalud_regular_pension && (
                            <span className="text-xs bg-cyan-100 text-cyan-800 px-2 py-1 rounded">EsSalud Pension</span>
                          )}
                          {codigo.afectaciones.contrib_solidaria_asist && (
                            <span className="text-xs bg-pink-100 text-pink-800 px-2 py-1 rounded">Contrib. Solid.</span>
                          )}
                        </div>
                      </div>
                      <svg className="w-5 h-5 text-gray-400 flex-shrink-0 ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                    </div>
                  </div>
                ))}
                </div>
              </div>
            </div>

            {/* Campo de monto si hay concepto seleccionado */}
            {conceptoSeleccionado && (
              <div className="bg-teal-50 border-t border-teal-200">
                <div className="px-6 py-4">
                <div className="flex items-center space-x-4">
                  <div className="flex-1">
                    <h4 className="font-medium text-teal-900 mb-2">
                      {conceptoSeleccionado.descripcion}
                    </h4>
                    <div className="flex items-center space-x-3">
                      <span className="bg-teal-100 text-teal-800 text-sm px-3 py-1 rounded font-mono">
                        {conceptoSeleccionado.codigo}
                      </span>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">S/</span>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          value={montoModal}
                          onChange={(e) => setMontoModal(e.target.value)}
                          className="pl-8 pr-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-500 text-sm w-32"
                          placeholder="0.00"
                          autoFocus
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                {/* Sección de fórmulas disponibles */}
                {mostrarFormulas && formulasDisponibles.length > 0 && (
                  <div className="border-t border-teal-200 px-6 py-4 max-h-80 overflow-y-auto">
                    <div className="mb-3">
                      <h5 className="text-sm font-semibold text-teal-800 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 002 2v14a2 2 0 002 2z" />
                        </svg>
                        Fórmulas Disponibles ({formulasDisponibles.length})
                      </h5>
                      
                      <div className="space-y-2 max-h-48 overflow-y-auto">
                        {formulasDisponibles.map((formula, index) => (
                          <div
                            key={formula.id}
                            onClick={() => seleccionarFormula(formula)}
                            className={`p-3 rounded-lg border cursor-pointer transition-colors ${
                              formulaSeleccionada?.id === formula.id
                                ? 'border-teal-500 bg-white shadow-sm'
                                : 'border-teal-300 bg-teal-25 hover:bg-white hover:border-teal-400'
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex-1">
                                <span className="font-mono text-sm bg-gray-100 px-2 py-1 rounded text-teal-800">
                                  {formula.formula}
                                </span>
                                {formula.regimen_laboral && (
                                  <p className="text-xs text-gray-600 mt-1">
                                    {formula.regimen_laboral.nombre}
                                  </p>
                                )}
                              </div>
                              {formulaSeleccionada?.id === formula.id && (
                                <svg className="w-4 h-4 text-teal-600" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Resultado del cálculo */}
                    {calculoFormula && (
                      <div className="bg-white rounded-lg p-3 border border-teal-300">
                        <h6 className="text-sm font-semibold text-gray-700 mb-2 flex items-center">
                          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                          </svg>
                          Cálculo Automático
                        </h6>
                        
                        <div className="space-y-2 text-sm">
                          <div>
                            <span className="text-gray-600">Fórmula: </span>
                            <span className="font-mono bg-gray-100 px-2 py-1 rounded text-xs">
                              {calculoFormula.formulaOriginal}
                            </span>
                          </div>
                          
                          <div>
                            <span className="text-gray-600">Con valores: </span>
                            <span className="font-mono bg-gray-100 px-2 py-1 rounded text-xs">
                              {calculoFormula.formulaReemplazada}
                            </span>
                          </div>
                          
                          <div className="flex items-center space-x-2">
                            <span className="text-gray-600">Resultado: </span>
                            <span className={`font-bold px-2 py-1 rounded text-sm ${
                              typeof calculoFormula.resultado === 'number' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-yellow-100 text-yellow-800'
                            }`}>
                              {typeof calculoFormula.resultado === 'number' 
                                ? `S/ ${calculoFormula.resultado.toFixed(2)}`
                                : calculoFormula.resultado
                              }
                            </span>
                            {typeof calculoFormula.resultado === 'number' && (
                              <button
                                onClick={() => setMontoModal(calculoFormula.resultado.toString())}
                                className="text-xs bg-teal-600 text-white px-2 py-1 rounded hover:bg-teal-700 transition-colors"
                              >
                                Usar este monto
                              </button>
                            )}
                          </div>

                          {/* Variables utilizadas */}
                          <div className="border-t border-gray-200 pt-2 mt-2">
                            <p className="text-xs text-gray-500 mb-1">Variables:</p>
                            <div className="flex flex-wrap gap-2">
                              {Object.entries(calculoFormula.variables).map(([variable, valor]) => (
                                <span key={variable} className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                                  {variable}: {typeof valor === 'number' ? valor.toFixed(2) : valor}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Mensaje si no hay fórmulas */}
                {mostrarFormulas && formulasDisponibles.length === 0 && (
                  <div className="border-t border-teal-200 px-6 py-4">
                    <div className="text-center py-4">
                      <svg className="w-8 h-8 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 002 2v14a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm text-gray-600">
                        No hay fórmulas disponibles para este concepto
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        Ingresa el monto manualmente
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}

            <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
              <button
                type="button"
                onClick={() => {
                  setBuscadorVisible(false);
                  setTerminoBusqueda('');
                  setResultadosBusqueda([]);
                  setTipoConceptoActual('');
                  setConceptoSeleccionado(null);
                  setMontoModal('');
                  setFormulasDisponibles([]);
                  setFormulaSeleccionada(null);
                  setCalculoFormula(null);
                  setMostrarFormulas(false);
                }}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              
              {conceptoSeleccionado && (
                <button
                  type="button"
                  onClick={confirmarConceptoConMonto}
                  disabled={!montoModal || parseFloat(montoModal) <= 0}
                  className={`px-6 py-2 font-medium rounded-lg transition-colors ${
                    montoModal && parseFloat(montoModal) > 0
                      ? 'bg-teal-600 text-white hover:bg-teal-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  Agregar Concepto
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 📊 INFORMACIÓN DISCRETA DE APIS CARGADAS - solo dato esencial */}
      {cargandoProgreso.apisCompletadas.length > 0 && cargandoProgreso.progreso === cargandoProgreso.total && (
        <div className="mt-6 mx-8 bg-gray-50 rounded-lg p-3 border border-gray-200">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-700">📊 Sistema Configurado</h4>
            <div className="text-xs">
              <span className="font-medium text-gray-600">APIs cargadas:</span>
              <span className="ml-1 text-green-700 font-semibold">
                {cargandoProgreso.apisCompletadas.length}/{cargandoProgreso.total}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmpleadoForm; 
